{
  "PDF preview": "PDF-Vorschau",
  "Zoom out": "Verkleinern",
  "Zoom in": "Vergrößern",
  "Fit width": "An Breite anpassen",
  "Choose valid collection columns without duplicates.": "Wählen Sie gültige Listenspalten ohne Duplikate.",
  "Settings": "Einstellungen",
  "Main menu": "Hauptmenü",
  "!CFG": "!CFG",
  "!REV": "!REV",
  ", not": ", nicht",
  ". Changing construction class requires a different identity.": ". Eine andere Bauart benötigt eine andere Identität.",
  ". It is shown only once.": ". Wird nur einmal angezeigt.",
  ". Where-used follows the actual structure—not the numbering path.": ". Verwendungen folgen der tatsächlichen Struktur, nicht dem Nummernpfad.",
  "? The history remains.": "? Der Verlauf bleibt erhalten.",
  "? The original part remains in the registry.": "? Das Originalteil bleibt im Register.",
  "A PIN needs a project/product version and at least one identity node (maximum depth 32).": "Eine PIN benötigt Projekt, Produktversion und mindestens einen Identitätsknoten; maximale Tiefe: 32.",
  "A change is awaiting confirmation": "Änderung wartet auf Bestätigung",
  "A controlled construction-class change requires another identity. Issue the new part rather than renaming this one.": "Eine kontrollierte Bauartänderung erfordert ein neues Teil statt einer Umbenennung.",
  "A new link will replace the previous invitation link for": "Der neue Link ersetzt die bisherige Einladung für",
  "A part cannot replace itself.": "Ein Teil kann sich nicht selbst ersetzen.",
  "A piece part cannot have a configuration.": "Ein Einzelteil kann keine Konfiguration haben.",
  "A piece part cannot have controlled children.": "Ein Einzelteil kann keine kontrollierten Unterteile haben.",
  "A piece part cannot retain controlled children.": "Ein Einzelteil kann keine kontrollierten Unterteile behalten.",
  "A qualified reference must select a released revision.": "Eine qualifizierte Referenz muss eine freigegebene Revision wählen.",
  "A verified Google email is required.": "Eine bestätigte Google-E-Mail-Adresse ist erforderlich.",
  "ALPHA": "ALPHA",
  "About {value0}": "Über {value0}",
  "Accept company invitation": "Firmeneinladung annehmen",
  "Account": "Konto",
  "Account and company settings": "Konto- und Firmeneinstellungen",
  "Active": "Aktiv",
  "Active assembly": "Aktuelle Baugruppe",
  "Add alias": "Externe Nummer hinzufügen",
  "Add code": "Code hinzufügen",
  "Add directional replacement": "Gerichteten Ersatz hinzufügen",
  "Add part": "Teil hinzufügen",
  "Add replacement": "Ersatz hinzufügen",
  "Add to {value0}": "Zu {value0} hinzufügen",
  "Adding…": "Wird hinzugefügt…",
  "Alias notes": "Notizen zur externen Nummer",
  "Alias organization": "Organisation der externen Nummer",
  "Alias type": "Art der externen Nummer",
  "All alias types": "Alle externen Nummernarten",
  "All companies": "Alle Firmen",
  "All selected child revisions must be released.": "Alle gewählten Unterteilrevisionen müssen freigegeben sein.",
  "All states": "Alle Status",
  "All types": "Alle Arten",
  "Aluminium": "Aluminium",
  "An assembly needs at least one controlled child before release.": "Vor der Freigabe benötigt eine Baugruppe mindestens ein kontrolliertes Unterteil.",
  "An example drawing change tightens a tolerance.": "Die beispielhafte Zeichnungsänderung verengt eine Toleranz.",
  "An external alias cannot impersonate another canonical part number.": "Eine externe Nummer darf keine andere kanonische Teilenummer vortäuschen.",
  "An identifier or historical alias already occupies the requested number.": "Die Nummer ist bereits durch eine Identität oder historische Weiterleitung belegt.",
  "An independently orderable configured product needs its own assembly P/N.": "Ein separat bestellbares konfiguriertes Produkt benötigt eine eigene Baugruppen-P/N.",
  "An invitation is already pending. Replace its link instead.": "Eine Einladung ist bereits offen. Ersetzen Sie deren Link.",
  "An occurrence cannot be moved to another owner by editing it.": "Eine Teilverwendung kann nicht durch Bearbeitung einem anderen Eigentümer zugeordnet werden.",
  "Another change was being saved. Retry this same request.": "Eine andere Änderung wurde gespeichert. Wiederholen Sie dieselbe Anfrage.",
  "Another owner must accept membership before removing the last owner.": "Vor dem Entfernen des letzten Eigentümers muss ein anderer die Mitgliedschaft annehmen.",
  "Another project": "Anderes Projekt",
  "Apply filters": "Filter anwenden",
  "Arm": "Arm",
  "Arm assembly": "Armbaugruppe",
  "As authored": "Wie angegeben",
  "Ask a company owner to register a new code.": "Bitten Sie einen Firmeneigentümer, einen neuen Code zu registrieren.",
  "Assembly": "Baugruppe",
  "Assembly configurations": "Baugruppenkonfigurationen",
  "Assignment correction": "Zuordnungskorrektur",
  "Back to blueprint": "Zurück zur Zeichnung",
  "Before controlled dependencies exist, correct the assignment with an audit entry. No old-number redirect is kept.": "Vor kontrollierten Abhängigkeiten lässt sich die Zuordnung mit Audit-Eintrag korrigieren. Keine Weiterleitung der alten Nummer.",
  "Best match": "Beste Übereinstimmung",
  "Bonded": "Geklebt",
  "Bonded assembly": "Geklebte Baugruppe",
  "Bonded grip": "Geklebter Griff",
  "Both leaders point to the same P/N.": "Beide Hinweislinien zeigen auf dieselbe P/N.",
  "CF": "CF",
  "Cancel": "Abbrechen",
  "Cancel {value0} edit": "Bearbeitung von {value0} abbrechen",
  "Carbon fibre": "Kohlefaser",
  "Change {value0}'s role": "Rolle von {value0} ändern",
  "Check result": "Ergebnis prüfen",
  "Choose Active, Obsolete or Retired.": "Wählen Sie Aktiv, Veraltet oder Stillgelegt.",
  "Choose Owner, Editor or Viewer.": "Wählen Sie Eigentümer, Bearbeiter oder Betrachter.",
  "Choose P, A, W, G or R.": "Wählen Sie P, A, W, G oder R.",
  "Choose a company": "Firma wählen",
  "Choose a measurement unit preference.": "Wählen Sie das bevorzugte Einheitensystem.",
  "Choose a part and exact revision from this company.": "Wählen Sie ein Teil und seine genaue Revision aus dieser Firma.",
  "Choose a product version from the default project.": "Wählen Sie eine Produktversion aus dem Standardprojekt.",
  "Choose a standard position or register its code in this company.": "Wählen Sie eine Standardposition oder registrieren Sie deren Code in dieser Firma.",
  "Choose a supplier, manufacturer or customer alias.": "Wählen Sie eine Lieferanten-, Hersteller- oder Kundennummer.",
  "Choose a supported interface language.": "Wählen Sie eine unterstützte Oberflächensprache.",
  "Choose a supported regional format.": "Wählen Sie ein unterstütztes Regionalformat.",
  "Choose a table density.": "Wählen Sie eine Tabellendichte.",
  "Choose a valid alias type.": "Wählen Sie eine gültige externe Nummernart.",
  "Choose a valid part state.": "Wählen Sie einen gültigen Teilestatus.",
  "Choose a valid part type.": "Wählen Sie eine gültige Teileart.",
  "Choose a valid results page and page size.": "Wählen Sie eine gültige Ergebnisseite und Seitengröße.",
  "Choose a valid search order.": "Wählen Sie eine gültige Suchreihenfolge.",
  "Choose a valid time zone.": "Wählen Sie eine gültige Zeitzone.",
  "Choose an assembly parent in the selected product version.": "Wählen Sie eine übergeordnete Baugruppe in dieser Produktversion.",
  "Choose an assembly parent outside this identity's descendant graph, in the selected product version.": "Wählen Sie eine Baugruppe dieser Produktversion außerhalb der Nachkommen dieser Identität.",
  "Choose an editable assembly and an exact part revision.": "Wählen Sie eine bearbeitbare Baugruppe und genaue Teilerevision.",
  "Choose each time": "Jedes Mal wählen",
  "Choose exactly one structure owner.": "Wählen Sie genau einen Struktureigentümer.",
  "Choose its revision and quantity to add it to this assembly.": "Wählen Sie Revision und Menge zum Einfügen in diese Baugruppe.",
  "Choose one structure owner.": "Wählen Sie einen Struktureigentümer.",
  "Choose the default company first.": "Wählen Sie zuerst die Standardfirma.",
  "Choose the part that can replace this one.": "Wählen Sie das Teil, das dieses ersetzen kann.",
  "Class": "Klasse",
  "Clear filters": "Filter löschen",
  "Close": "Schließen",
  "Close reuse parts": "Teilewiederverwendung schließen",
  "Close {value0}": "{value0} schließen",
  "Code": "Code",
  "Comfortable": "Komfortabel",
  "Compact": "Kompakt",
  "Companies": "Unternehmen",
  "Company": "Unternehmen",
  "Company code": "Unternehmenscode",
  "Company name": "Unternehmensname",
  "Company not found.": "Firma nicht gefunden.",
  "Company parts": "Firmenteile",
  "Company settings": "Firmeneinstellungen",
  "Company-wide role": "Firmenweite Rolle",
  "Configuration": "Konfiguration",
  "Configuration name": "Konfigurationsname",
  "Configurations": "Konfigurationen",
  "Configurations apply to assemblies, not piece parts.": "Konfigurationen gelten für Baugruppen, nicht für Einzelteile.",
  "Construction classes": "Bauarten",
  "Copy a revision of this part.": "Eine Revision dieses Teils kopieren.",
  "Correct engineering identity": "Technische Identität korrigieren",
  "Corrected text": "Korrigierter Text",
  "Correction & replacement": "Korrektur und Ersatz",
  "Correction reason": "Korrekturgrund",
  "Cover": "Abdeckung",
  "Cover numbered beneath it": "Darunter nummerierte Abdeckung",
  "Cover revisions": "Abdeckungsrevisionen",
  "Cover · 1 each · forearm": "Abdeckung · 1 Stück · Unterarm",
  "Create company": "Firma erstellen",
  "Create configuration": "Konfiguration erstellen",
  "Create invitation": "Einladung erstellen",
  "Create project": "Projekt erstellen",
  "Create variant": "Variante erstellen",
  "Create version": "Version erstellen",
  "Current structure": "Aktuelle Struktur",
  "Default quantity unit": "Standardmengeneinheit",
  "Default workspace": "Standardarbeitsbereich",
  "Description": "Beschreibung",
  "Details": "Details",
  "Different identity": "Andere Identität",
  "Directional replacements": "Gerichtete Ersetzungen",
  "Draft": "Entwurf",
  "Drawing unavailable. Part-number examples remain interactive.": "Zeichnung nicht verfügbar. Teilenummernbeispiele bleiben interaktiv.",
  "ER": "ER",
  "Edit company": "Firma bearbeiten",
  "Edit configuration": "Konfiguration bearbeiten",
  "Edit details": "Details bearbeiten",
  "Edit part details": "Teiledetails bearbeiten",
  "Edit part use": "Teileverwendung bearbeiten",
  "Edit product version": "Produktversion bearbeiten",
  "Edit project": "Projekt bearbeiten",
  "Editor": "Bearbeiter",
  "Engineering": "Engineering",
  "Engineering Registry": "Engineering Registry",
  "Enter a canonical PIN.": "Geben Sie eine kanonische PIN ein.",
  "Enter a position code.": "Geben Sie einen Positionscode ein.",
  "Enter a positive quantity and a unit.": "Geben Sie eine positive Menge und Einheit ein.",
  "Enter a valid email address.": "Geben Sie eine gültige E-Mail-Adresse ein.",
  "Enter a variant code.": "Geben Sie einen Variantencode ein.",
  "Exact child revision": "Genaue Unterteilrevision",
  "Exact children in this baseline": "Genaue Unterteile dieser Baseline",
  "Existing codes…": "Vorhandene Codes…",
  "Existing hand, used in V": "Vorhandene Hand, verwendet in V",
  "Existing part": "Vorhandenes Teil",
  "Explain": "Erklären",
  "External aliases": "Externe Nummern",
  "External part number": "Externe Teilenummer",
  "Filters": "Filter",
  "Find an existing part": "Vorhandenes Teil suchen",
  "Find parts": "Teile suchen",
  "Find {value0}": "{value0} suchen",
  "For an unrelated part, leave Related part empty to allocate a new number.": "Bei unabhängigen Teilen lassen Sie das verwandte Teil leer, um eine neue Nummer zu vergeben.",
  "Forearm cover": "Unterarmabdeckung",
  "Front view · left/right is the robot’s own left/right": "Vorderansicht · links/rechts aus Sicht des Roboters",
  "Front view. The robot’s right hand is on the left of the drawing; its left hand is on the right.": "Vorderansicht: Die rechte Roboterhand steht links im Bild, die linke rechts.",
  "Google account email": "Google-Konto-E-Mail",
  "Google could not verify this sign-in. Try again.": "Google konnte die Anmeldung nicht bestätigen. Erneut versuchen.",
  "Google sign-in could not load. Check your connection and try again.": "Google-Anmeldung konnte nicht geladen werden. Verbindung prüfen und erneut versuchen.",
  "Google sign-in is not configured.": "Google-Anmeldung ist nicht eingerichtet.",
  "Hand identities": "Handidentitäten",
  "Head casing": "Kopfgehäuse",
  "Hide": "Ausblenden",
  "Historical rename": "Historische Umbenennung",
  "History": "Verlauf",
  "Hole Ø6 mm · tolerance ±": "Bohrung Ø6 mm · Toleranz ±",
  "Identity family": "Identitätsfamilie",
  "Identity history examples": "Beispiele des Identitätsverlaufs",
  "Illustrative example · not your registry": "Anschauungsbeispiel · nicht Ihr Register",
  "Imperial": "Imperial",
  "Interactive robot part numbers": "Interaktive Roboterteilenummern",
  "Invitation link": "Einladungslink",
  "Invitation not found.": "Einladung nicht gefunden.",
  "Invite person": "Person einladen",
  "Issue part number": "Teilenummer vergeben",
  "Issue variant": "Variante vergeben",
  "Issuing the cover beneath it appends": "Eine darunter nummerierte Abdeckung ergänzt",
  "It does not tell you where it is used now.": "Das zeigt nicht die heutige Verwendung.",
  "Keep the part number and name columns; each column may appear only once.": "Teilenummer und Name müssen bleiben; jede Spalte darf nur einmal vorkommen.",
  "Knee pin ×2": "Kniestift ×2",
  "Language": "Sprache",
  "Left / right": "Links / rechts",
  "Left hand": "Linke Hand",
  "Left hand · 1 each · wrist": "Linke Hand · 1 Stück · Handgelenk",
  "Loading…": "Wird geladen…",
  "Main navigation": "Hauptnavigation",
  "Material": "Werkstoff",
  "Meaning": "Bedeutung",
  "Measurement units": "Maßeinheiten",
  "Members": "Mitglieder",
  "Metric": "Metrisch",
  "Move {column} down": "{column} nach unten verschieben",
  "Move {column} up": "{column} nach oben verschieben",
  "Name": "Name",
  "Navigation": "Navigation",
  "Neither family membership nor a variant code promises interchangeability.": "Weder Familienzugehörigkeit noch Variantencode garantieren Austauschbarkeit.",
  "New assembly": "Neue Baugruppe",
  "New camera in V2": "Neue Kamera in V2",
  "New camera, first numbered in V2": "Neue Kamera, erstmals in V2 nummeriert",
  "New codes are registered by a company owner.": "Neue Codes werden von einem Firmeneigentümer registriert.",
  "New company": "Neue Firma",
  "New configuration": "Neue Konfiguration",
  "New part": "Neues Teil",
  "New product version": "Neue Produktversion",
  "New project": "Neues Projekt",
  "New revision": "Neue Revision",
  "New version": "Neue Version",
  "No choices available.": "Keine Auswahl verfügbar.",
  "No parts yet.": "Noch keine Teile.",
  "No selected occurrences.": "Keine Teilverwendungen ausgewählt.",
  "None": "Keine",
  "Not confirmed yet. Retry the saved change to resolve it safely.": "Noch unbestätigt. Wiederholen Sie die gespeicherte Änderung zur sicheren Klärung.",
  "Not found.": "Nicht gefunden.",
  "Notes": "Notizen",
  "Numbering beneath an assembly does not place the cover in its structure. Adding an occurrence is separate; reuse elsewhere keeps this P/N.": "Nummerierung unter einer Baugruppe fügt die Abdeckung nicht ihrer Struktur hinzu. Das Einfügen ist separat; Wiederverwendung behält diese P/N.",
  "Numbering concept": "Nummerierungskonzept",
  "Numbering path": "Nummernpfad",
  "Obsolete": "Veraltet",
  "Old text": "Alter Text",
  "Only !REV changes.": "Nur !REV ändert sich.",
  "Only company owners can manage membership.": "Nur Firmeneigentümer können Mitgliedschaften verwalten.",
  "Only the configured administrator can create companies.": "Nur der eingerichtete Administrator kann Firmen erstellen.",
  "Open PIN": "PIN öffnen",
  "Open navigation": "Navigation öffnen",
  "Open project explorer": "Projektnavigation öffnen",
  "Organization": "Organisation",
  "Original identity": "Ursprüngliche Identität",
  "Overview": "Übersicht",
  "Owner": "Eigentümer",
  "P/N prefix": "P/N-Präfix",
  "P/N preview": "P/N-Vorschau",
  "Page not found": "Seite nicht gefunden",
  "Part": "Teil",
  "Part name": "Teilename",
  "Part number": "Teilenummer",
  "Part number preview": "Teilenummernvorschau",
  "Part number ↑": "Teilenummer ↑",
  "Part number ↓": "Teilenummer ↓",
  "Part number, name, material or alias": "Teilenummer, Name, Werkstoff oder externe Nummer",
  "Part numbering guide": "Leitfaden zur Teilenummerierung",
  "Part prefixes change together; controlled historical identifiers keep redirects.": "Teilepräfixe ändern sich gemeinsam; kontrollierte historische Kennungen behalten Weiterleitungen.",
  "Part record": "Teiledatensatz",
  "Part section": "Teilebereich",
  "Part type": "Teileart",
  "Parts": "Teile",
  "Parts first numbered in this product version.": "Erstmals in dieser Produktversion nummerierte Teile.",
  "Per page": "Pro Seite",
  "Personal preferences": "Persönliche Einstellungen",
  "Piece": "Einzelteil",
  "Piece part": "Einzelteil",
  "Piece parts cannot have controlled children.": "Einzelteile können keine kontrollierten Unterteile enthalten.",
  "Piece parts do not have assembly configurations.": "Einzelteile haben keine Baugruppenkonfigurationen.",
  "Position": "Position",
  "Position code": "Positionscode",
  "Position codes contain 1–12 uppercase letters.": "Positionscodes enthalten 1–12 lateinische Großbuchstaben.",
  "Product shown": "Angezeigtes Produkt",
  "Product version": "Produktversion",
  "Product versions": "Produktversionen",
  "Project": "Projekt",
  "Project / product version": "Projekt / Produktversion",
  "Project code": "Projektcode",
  "Project explorer": "Projektnavigation",
  "Project name": "Projektname",
  "Project settings": "Projekteinstellungen",
  "Project workspace": "Projektarbeitsbereich",
  "Projects": "Projekte",
  "Quantity": "Menge",
  "Quantity and position belong to each occurrence, not to the part’s identity. Both knees select revision 1.": "Menge und Position gehören zur jeweiligen Verwendung, nicht zur Teileidentität. Beide Knie wählen Revision 1.",
  "Quantity must be positive, at most one billion, with no more than six decimal places.": "Die Menge muss positiv, höchstens eine Milliarde und maximal sechsstellig nach dem Komma sein.",
  "ROBOT project": "Projekt ROBOT",
  "Reason for changing the code": "Grund der Codeänderung",
  "Reason for correcting the code": "Grund der Codekorrektur",
  "Reason for correcting version number": "Grund der Versionsnummernkorrektur",
  "Regional format": "Regionalformat",
  "Register code": "Code registrieren",
  "Register variant code": "Variantencode registrieren",
  "Registered meanings cannot be reassigned after use.": "Registrierte Bedeutungen können nach Verwendung nicht neu zugewiesen werden.",
  "Registered {value0} codes": "Registrierte {value0}-Codes",
  "Registry": "Register",
  "Related identities are not automatically interchangeable.": "Verwandte Identitäten sind nicht automatisch austauschbar.",
  "Related part": "Verwandtes Teil",
  "Release configuration": "Konfiguration freigeben",
  "Release each selected child revision before releasing this assembly.": "Geben Sie vor dieser Baugruppe alle gewählten Unterteilrevisionen frei.",
  "Release the assembly revision before releasing this configuration.": "Geben Sie die Baugruppenrevision vor dieser Konfiguration frei.",
  "Released": "Freigegeben",
  "Released arm baseline": "Freigegebene Arm-Baseline",
  "Released configurations cannot be changed. Create a new configuration.": "Freigegebene Konfigurationen sind unveränderlich. Erstellen Sie eine neue.",
  "Released definitions stay unchanged. Create a new revision to make changes.": "Freigegebene Definitionen bleiben unverändert. Erstellen Sie eine neue Revision.",
  "Released structures stay unchanged. Create a new revision.": "Freigegebene Strukturen bleiben unverändert. Erstellen Sie eine neue Revision.",
  "Reload saved preferences": "Gespeicherte Einstellungen neu laden",
  "Reload structure": "Struktur neu laden",
  "Remove": "Entfernen",
  "Remove access": "Zugriff entfernen",
  "Remove alias": "Externe Nummer entfernen",
  "Remove external alias?": "Externe Nummer entfernen?",
  "Remove from assembly": "Aus Baugruppe entfernen",
  "Remove from assembly?": "Aus Baugruppe entfernen?",
  "Remove saved search": "Gespeicherte Suche entfernen",
  "Remove saved search?": "Gespeicherte Suche entfernen?",
  "Remove {value0}'s access?": "Zugriff von {value0} entfernen?",
  "Replace invitation link?": "Einladungslink ersetzen?",
  "Replace link": "Link ersetzen",
  "Replacement": "Ersatz",
  "Replacement conditions": "Ersatzbedingungen",
  "Results per page": "Ergebnisse pro Seite",
  "Retired": "Stillgelegt",
  "Retry saved change": "Gespeicherte Änderung wiederholen",
  "Reuse & structure": "Wiederverwendung und Struktur",
  "Reuse parts": "Teile wiederverwenden",
  "Reuse source": "Quelle der Wiederverwendung",
  "Rev": "Rev.",
  "Revision": "Revision",
  "Revision and configuration numbers must be positive.": "Revisions- und Konfigurationsnummern müssen positiv sein.",
  "Revision structures are selected by revision, not by project snapshot.": "Revisionsstrukturen werden nach Revision gewählt, nicht nach Projektstand.",
  "Revisions": "Revisionen",
  "Revoke invitation": "Einladung widerrufen",
  "Revoke invitation?": "Einladung widerrufen?",
  "Right hand": "Rechte Hand",
  "Riveted": "Genietet",
  "Riveted assembly": "Genietete Baugruppe",
  "Riveted chest panel": "Genietete Brustplatte",
  "Robot numbering guide": "Roboter-Nummerierungsleitfaden",
  "Same assembly and revision, different frozen selections.": "Gleiche Baugruppe und Revision, unterschiedliche eingefrorene Auswahlen.",
  "Same cover identity": "Gleiche Abdeckungsidentität",
  "Save": "Speichern",
  "Save as a new search": "Als neue Suche speichern",
  "Save changes": "Änderungen speichern",
  "Save configuration": "Konfiguration speichern",
  "Save project": "Projekt speichern",
  "Save replacement": "Ersatz speichern",
  "Save search": "Suche speichern",
  "Saved change recovery": "Wiederherstellung gespeicherter Änderungen",
  "Saved searches": "Gespeicherte Suchen",
  "Saving…": "Wird gespeichert…",
  "Search": "Suchen",
  "Search columns and order": "Suchspalten und Reihenfolge",
  "Search company parts": "Firmenteile suchen",
  "Search filters": "Suchfilter",
  "Search name": "Suchname",
  "Search order": "Suchreihenfolge",
  "Search part numbers or names": "Teilenummern oder Namen suchen",
  "Searching…": "Suche…",
  "Search…": "Suchen…",
  "Select a cover to see its P/N on the robot. Geometry can look alike while material and engineering definition differ.": "Wählen Sie eine Abdeckung für ihre P/N am Roboter. Ähnliche Geometrie kann andere Werkstoffe und Definitionen haben.",
  "Select a revision of this assembly.": "Wählen Sie eine Revision dieser Baugruppe.",
  "Select a variant code registered in this company.": "Wählen Sie einen in dieser Firma registrierten Variantencode.",
  "Select an assembly revision.": "Wählen Sie eine Baugruppenrevision.",
  "Select an exact child revision.": "Wählen Sie eine genaue Unterteilrevision.",
  "Select at least one child occurrence before releasing an assembly configuration.": "Wählen Sie vor der Konfigurationsfreigabe mindestens eine Unterteilverwendung.",
  "Selected engineering definition": "Gewählte technische Definition",
  "Selected revision": "Gewählte Revision",
  "Send this link to": "Diesen Link senden an",
  "Separable": "Trennbar",
  "Separable assembly": "Lösbare Baugruppe",
  "Several parts use this external alias. Search it and choose the correct part.": "Mehrere Teile verwenden diese externe Nummer. Suchen Sie danach und wählen Sie das richtige Teil.",
  "Show V": "V anzeigen",
  "Show all company parts": "Alle Firmenteile anzeigen",
  "Show {column}": "{column} anzeigen",
  "Showing the first": "Angezeigt: die ersten",
  "Shown in product version V": "Gezeigt in Produktversion V",
  "Sign in first.": "Melden Sie sich zuerst an.",
  "Sign in to continue.": "Zum Fortfahren anmelden.",
  "Sign in to your engineering workspace.": "Melden Sie sich in Ihrem Engineering-Arbeitsbereich an.",
  "Sign in with the Google account named on this invitation.": "Melden Sie sich mit dem in der Einladung genannten Google-Konto an.",
  "Sign out": "Abmelden",
  "Signing in…": "Anmeldung…",
  "Skip to content": "Zum Inhalt springen",
  "Sort": "Sortierung",
  "Standard position meanings cannot be changed.": "Standardpositionsbedeutungen können nicht geändert werden.",
  "State": "Status",
  "Structure": "Struktur",
  "Structure snapshot": "Strukturstand",
  "Structure snapshot not found.": "Strukturstand nicht gefunden.",
  "Switch to V2: the reused hands and knee pins keep their V1 numbers. Only the new camera receives a V2 number. ROBOT is the project code; V1/V2 are product versions, not part revisions.": "Wechseln Sie zu V2: Wiederverwendete Hände und Kniestifte behalten V1-Nummern. Nur die neue Kamera erhält eine V2-Nummer. ROBOT ist der Projektcode; V1/V2 sind Produktversionen, keine Teilerevisionen.",
  "Switch to {value0} appearance": "Zur Darstellung {value0} wechseln",
  "Table density": "Tabellendichte",
  "That record was not found in this company.": "Dieser Datensatz wurde in der Firma nicht gefunden.",
  "The corrected identifier must differ from the current identifier.": "Die korrigierte Kennung muss sich von der aktuellen unterscheiden.",
  "The correction creates duplicate identifiers.": "Die Korrektur erzeugt doppelte Kennungen.",
  "The identifier number is outside the supported positive integer range.": "Die Kennungsnummer liegt außerhalb des unterstützten positiven Ganzzahlbereichs.",
  "The next number changed. Review the updated preview, then issue again.": "Die nächste Nummer hat sich geändert. Prüfen Sie die Vorschau und vergeben Sie erneut.",
  "The number is allocated within its prefix:": "Die Nummer wird innerhalb ihres Präfixes vergeben:",
  "The old item remains its own record. Example condition: the replacement cover fits only with an adapter. The reverse is not implied; replacement is not an alias.": "Das alte Teil behält seinen Datensatz. Beispiel: Die Ersatzabdeckung passt nur mit Adapter. Die Gegenrichtung ist nicht impliziert; Ersatz ist kein Alias.",
  "The old released definition remains available; an unqualified P/N identifies the item, not “latest revision”.": "Die alte freigegebene Definition bleibt verfügbar; eine unqualifizierte P/N bezeichnet das Teil, nicht die „neueste Revision“.",
  "The part is saved in the company registry.": "Das Teil ist im Firmenregister gespeichert.",
  "The pending invitation for": "Die offene Einladung für",
  "The prefix is ROBOT-V1.2A.": "Das Präfix ist ROBOT-V1.2A.",
  "The related family must have the same product version and origin parent.": "Die verwandte Familie benötigt dieselbe Produktversion und denselben Ursprungselternknoten.",
  "The request could not be completed. Retry or reload; confirm any pending change before editing again.": "Anfrage fehlgeschlagen. Wiederholen oder neu laden; vor weiteren Änderungen ausstehende Änderungen bestätigen.",
  "The request could not be read. Check your input and try again.": "Anfrage konnte nicht gelesen werden. Eingabe prüfen und erneut versuchen.",
  "The revision and configuration select different assembly baselines.": "Revision und Konfiguration wählen verschiedene Baugruppen-Baselines.",
  "The same forearm cover shape in silver aluminium on the left and woven carbon fibre on the right": "Gleiche Unterarmabdeckung: links silbernes Aluminium, rechts gewebte Kohlefaser",
  "The selected part may replace": "Das gewählte Teil kann ersetzen:",
  "They share a family number, not an interchangeable identity. “Not sided” omits the qualifier; issuing one side does not issue the other.": "Gemeinsame Familiennummer bedeutet keine Austauschbarkeit. „Ohne Seite“ lässt den Zusatz weg; eine Seite erzeugt nicht die andere.",
  "This PIN was not found in the selected company.": "Diese PIN wurde in der gewählten Firma nicht gefunden.",
  "This baseline uses multiple revisions of the child. Specify !REV explicitly.": "Diese Baseline nutzt mehrere Unterteilrevisionen. Geben Sie !REV ausdrücklich an.",
  "This change conflicts with an existing record. Reload and review your changes.": "Änderung kollidiert mit einem vorhandenen Datensatz. Neu laden und prüfen.",
  "This child revision is not in the selected parent baseline.": "Diese Unterteilrevision gehört nicht zur gewählten übergeordneten Baseline.",
  "This code was registered elsewhere. Review its meaning before using it.": "Dieser Code wurde anderswo registriert. Prüfen Sie vor Verwendung seine Bedeutung.",
  "This configuration is already released.": "Diese Konfiguration ist bereits freigegeben.",
  "This destination is read-only or the revision is unavailable.": "Ziel ist schreibgeschützt oder Revision nicht verfügbar.",
  "This family number belongs to another family. Issue a related identity explicitly instead.": "Diese Nummer gehört einer anderen Familie. Erstellen Sie ausdrücklich eine verwandte Identität.",
  "This identifier is reserved by a historical rename.": "Diese Kennung ist durch eine historische Umbenennung reserviert.",
  "This invitation has expired or been revoked.": "Diese Einladung ist abgelaufen oder widerrufen.",
  "This invitation has expired, was replaced, or is no longer pending.": "Einladung abgelaufen, ersetzt oder nicht mehr offen.",
  "This invitation is no longer pending.": "Diese Einladung ist nicht mehr offen.",
  "This is the next available number, not a reservation. The number is checked again when you issue. If another person takes it first, the form stays open with an updated preview.": "Dies ist die nächste verfügbare Nummer, keine Reservierung. Bei Vergabe wird erneut geprüft. Wird sie vorher vergeben, bleibt das Formular mit aktualisierter Vorschau offen.",
  "This occurrence would create a structure cycle.": "Diese Verwendung würde einen Strukturzyklus erzeugen.",
  "This part number already exists. Choose a different variant or position.": "Diese Teilenummer existiert bereits. Wählen Sie eine andere Variante oder Position.",
  "This person is already a member. Change their role in Members.": "Diese Person ist bereits Mitglied. Ändern Sie ihre Rolle unter Mitglieder.",
  "This product version number is already assigned.": "Diese Produktversionsnummer ist bereits vergeben.",
  "This project code already exists.": "Dieser Projektcode existiert bereits.",
  "This record changed. Reload it before saving again.": "Datensatz geändert. Vor dem Speichern neu laden.",
  "This released configuration does not exist.": "Diese freigegebene Konfiguration existiert nicht.",
  "This replacement direction already exists.": "Diese Ersatzrichtung existiert bereits.",
  "This revision does not exist.": "Diese Revision existiert nicht.",
  "This revision is already released.": "Diese Revision ist bereits freigegeben.",
  "This saved search belongs to another person.": "Diese gespeicherte Suche gehört einer anderen Person.",
  "This updates the project's part-number prefixes. Controlled identities retain historical redirects.": "Aktualisiert die Teilenummernpräfixe des Projekts. Kontrollierte Identitäten behalten historische Weiterleitungen.",
  "Time zone": "Zeitzone",
  "Try again": "Erneut versuchen",
  "Two hands, two identities.": "Zwei Hände, zwei Identitäten.",
  "Two occurrences, one part": "Zwei Verwendungen, ein Teil",
  "Unit": "Einheit",
  "Unsaved search": "Ungespeicherte Suche",
  "Use PROJECT-V1 followed by unpadded identity nodes.": "Verwenden Sie PROJECT-V1 gefolgt von Identitätsknoten ohne führende Nullen.",
  "Use a positive product version number.": "Verwenden Sie eine positive Produktversionsnummer.",
  "Use a positive, unpadded family number.": "Verwenden Sie eine positive Familiennummer ohne führende Nullen.",
  "Use a whole number for the search filter.": "Verwenden Sie eine ganze Zahl im Suchfilter.",
  "Use an uppercase code starting with a letter, containing letters, numbers or hyphens (maximum 32 characters).": "Großgeschriebener Code mit Buchstabenbeginn, nur Buchstaben, Zahlen oder Bindestriche, maximal 32 Zeichen.",
  "Use code": "Code verwenden",
  "Use number/class, optional !VARIANT and #POSITION, then !REV and !CFG in that order. Leading zeroes and colon qualifiers are not valid.": "Zahl/Bauart, optional !VARIANT und #POSITION, dann !REV und !CFG in dieser Reihenfolge. Keine führenden Nullen oder Doppelpunktzusätze.",
  "Using this pin in V2 or another project in the same company keeps": "Die Verwendung dieses Stifts in V2 oder einem anderen Firmenprojekt behält",
  "V1 tells you where a part was first numbered.": "V1 zeigt, wo das Teil erstmals nummeriert wurde.",
  "Variant code": "Variantencode",
  "Variant codes": "Variantencodes",
  "Variant codes contain uppercase letters and cannot start with REV or CFG.": "Variantencodes enthalten Großbuchstaben und dürfen nicht mit REV oder CFG beginnen.",
  "Variants & replacements": "Varianten und Ersatz",
  "Version name": "Versionsname",
  "Version name (optional)": "Versionsname (optional)",
  "Version number": "Versionsnummer",
  "View parts": "Teile anzeigen",
  "Viewer": "Betrachter",
  "Wait for a valid part-number preview.": "Warten Sie auf eine gültige Teilenummernvorschau.",
  "Welded": "Geschweißt",
  "Welded assembly": "Geschweißte Baugruppe",
  "Welded torso frame": "Geschweißter Rumpfrahmen",
  "Where used": "Verwendung",
  "With controlled dependencies, old text redirects to the renamed item. !REV1 still resolves that exact historical revision; configurations and descendant numbering are preserved.": "Bei kontrollierten Abhängigkeiten verweist der alte Text auf das umbenannte Teil. !REV1 bleibt die genaue historische Revision; Konfigurationen und Nachkommennummern bleiben erhalten.",
  "Withdraw permission for": "Berechtigung entziehen für",
  "Withdraw replacement": "Ersatz zurückziehen",
  "Withdraw replacement?": "Ersatz zurückziehen?",
  "You are already a member of this company.": "Sie sind bereits Mitglied dieser Firma.",
  "Your form session expired. Refresh your session, then retry the saved change.": "Formularsitzung abgelaufen. Sitzung erneuern und gespeicherte Änderung wiederholen.",
  "Your preferences changed. Reload before saving again.": "Ihre Einstellungen wurden geändert. Vor dem Speichern neu laden.",
  "across this company": "in dieser Firma",
  "and": "und",
  "at {value0}": "bei {value0}",
  "dark": "dunkel",
  "distinguish the right-hand and left-hand forms. The two connected labels point to the robot’s own hands, not the viewer’s sides.": "unterscheiden rechte und linke Ausführung. Die Beschriftungen zeigen auf die eigenen Hände des Roboters, nicht auf Betrachterseiten.",
  "from": "von",
  "from this structure? The original part remains in the company registry.": "aus dieser Struktur? Das Originalteil bleibt im Firmenregister.",
  "in this example.": "in diesem Beispiel.",
  "is the construction class, not a revision. P is a single piece without controlled children; A, W, G and R are assemblies joined in different ways.": "ist die Bauart, keine Revision. P ist ein Einzelteil ohne kontrollierte Unterteile; A, W, G und R sind unterschiedlich gefügte Baugruppen.",
  "issued.": "vergeben.",
  "light": "hell",
  "match": "Treffer",
  "matches": "Treffer",
  "mm": "mm",
  "of": "von",
  "only under the stated conditions.": "nur unter den genannten Bedingungen.",
  "parts. Search the company to find additional matches.": "Teile. Durchsuchen Sie die Firma nach weiteren Treffern.",
  "to replace": "als Ersatz für",
  "will lose access to every project and part in this company.": "verliert Zugriff auf alle Projekte und Teile dieser Firma.",
  "will no longer work.": "funktioniert nicht mehr.",
  "{field} must contain {minimum}–{maximum} characters.": "{field} muss {minimum}–{maximum} Zeichen enthalten.",
  "{value0} added to {value1}.": "{value0} zu {value1} hinzugefügt.",
  "{value0} code": "{value0}-Code",
  "{value0} cover example": "{value0}-Abdeckungsbeispiel",
  "{value0} editor": "{value0}-Editor",
  "{value0} meaning": "{value0}-Bedeutung",
  "{value0} · Rev {value1}": "{value0} · Rev. {value1}",
  "{value0}!REV1": "{value0}!REV1",
  "{value0}!REV{value1}": "{value0}!REV{value1}",
  "· 1 each": "· je 1 Stück",
  "· Refine your search for other matches.": "· Verfeinern Sie die Suche für weitere Treffer.",
  "· Revision {value0}": "· Revision {value0}",
  "!CF": "!CF",
  "!CF changes the identity, not its revision.": "!CF ändert die Identität, nicht die Revision.",
  "!CFG{value0}": "!CFG{value0}",
  "!REV1": "!REV1",
  "!REV{value0}": "!REV{value0}",
  "? Its definition and exact child occurrences become immutable. Further changes require a new revision.": "? Definition und genaue Unterteilverwendungen werden unveränderlich. Weitere Änderungen benötigen eine neue Revision.",
  "Accept invitation": "Einladung annehmen",
  "Accepting…": "Wird angenommen…",
  "Actions": "Aktionen",
  "Actions for {value0}": "Aktionen für {value0}",
  "Add description": "Beschreibung hinzufügen",
  "Add external alias": "Externe Nummer hinzufügen",
  "An origin parent is selected.": "Ein Ursprungselternknoten ist ausgewählt.",
  "Applicability / effectivity": "Anwendbarkeit / Gültigkeit",
  "Apply identity correction": "Identitätskorrektur anwenden",
  "Assembly revision": "Baugruppenrevision",
  "Both covers share": "Beide Abdeckungen teilen",
  "Change role": "Rolle ändern",
  "Checking number…": "Nummer wird geprüft…",
  "Child REV": "Unterteil-Rev.",
  "Choose a project": "Projekt auswählen",
  "Choose a revision to inspect its exact definition.": "Wählen Sie eine Revision für ihre genaue Definition.",
  "Choose a revision to view its exact structure.": "Wählen Sie eine Revision für ihre genaue Struktur.",
  "Choose an assembly in the selected product version.": "Wählen Sie eine Baugruppe der gewählten Produktversion.",
  "Choose an exact assembly revision.": "Wählen Sie eine genaue Baugruppenrevision.",
  "Choose another company": "Andere Firma wählen",
  "Collapse": "Einklappen",
  "Company access unavailable": "Firmenzugriff nicht verfügbar",
  "Copied.": "Kopiert.",
  "Copy link": "Link kopieren",
  "Copy was unavailable. Select the link and copy it manually.": "Kopieren nicht verfügbar. Link markieren und manuell kopieren.",
  "Correct identity": "Identität korrigieren",
  "Custom position…": "Eigene Position…",
  "Definition": "Definition",
  "Details for {value0}": "Details zu {value0}",
  "Edit": "Bearbeiten",
  "Edit alias {value}": "Externe Nummer {value} bearbeiten",
  "Edit definition": "Definition bearbeiten",
  "Edit external alias": "Externe Nummer bearbeiten",
  "Empty definition": "Leere Definition",
  "Expand": "Aufklappen",
  "Family number": "Familiennummer",
  "Freeze CFG": "CFG einfrieren",
  "Google sign-in is not configured. The administrator needs to restore the sign-in configuration.": "Google-Anmeldung nicht eingerichtet. Der Administrator muss die Konfiguration wiederherstellen.",
  "Identity": "Identität",
  "In this example company, CF is registered as “carbon fibre”. Other companies may register different meanings.": "In der Beispielfirma bedeutet CF „Kohlefaser“. Andere Firmen können andere Bedeutungen registrieren.",
  "Include selected revision": "Gewählte Revision einschließen",
  "Invitations": "Einladungen",
  "Join": "Verbindung",
  "Left": "Links",
  "Next": "Weiter",
  "No child parts.": "Keine Unterteile.",
  "No companies yet.": "Noch keine Firmen.",
  "No configurations yet.": "Noch keine Konfigurationen.",
  "No external aliases.": "Keine externen Nummern.",
  "No invitations.": "Keine Einladungen.",
  "No matching choices.": "Keine passenden Optionen.",
  "No matching parts.": "Keine passenden Teile.",
  "No parts in this structure yet.": "Noch keine Teile in dieser Struktur.",
  "No product versions in this project.": "Keine Produktversionen in diesem Projekt.",
  "No product versions yet.": "Noch keine Produktversionen.",
  "No projects yet.": "Noch keine Projekte.",
  "No replacement relationships.": "Keine Ersatzbeziehungen.",
  "No variant code": "Kein Variantencode",
  "No variant codes registered.": "Keine Variantencodes registriert.",
  "Not reserved": "Nicht reserviert",
  "Numbered directly under the product version.": "Direkt unter der Produktversion nummeriert.",
  "Open assembly {value0}": "Baugruppe {value0} öffnen",
  "Open resolved configuration": "Aufgelöste Konfiguration öffnen",
  "Origin product version": "Ursprungsproduktversion",
  "Other positions": "Andere Positionen",
  "Other positions add a distinct identity qualifier: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR, and #TOP/#MIDVERT/#BOTTOM. The two Mid choices belong to different axes. Custom codes have a company-defined meaning. This is not the location or position number of a reused part in an assembly.": "Andere Positionen ergänzen Identitätszusätze: #N/#S, #W/#E, #FRONT/#MIDLONG/#REAR und #TOP/#MIDVERT/#BOTTOM. Die beiden Mittelpositionen gehören zu verschiedenen Achsen. Eigene Codes haben firmendefinierte Bedeutungen. Dies ist nicht die Einbauposition eines wiederverwendeten Teils.",
  "Other positions…": "Andere Positionen…",
  "Page {page} of {pages}": "Seite {page} von {pages}",
  "Part / P/N": "Teil / P/N",
  "Part section not found.": "Teilebereich nicht gefunden.",
  "Parts in {value0}": "Teile in {value0}",
  "Person": "Person",
  "Piece parts have no child structure.": "Einzelteile haben keine Unterstruktur.",
  "Position for occurrence {value0}": "Position der Verwendung {value0}",
  "Previous": "Zurück",
  "Product root": "Produktwurzel",
  "Product structure": "Produktstruktur",
  "Qty": "Menge",
  "Quantity for occurrence {value0}": "Menge der Verwendung {value0}",
  "Quantity for {value0} {value1}": "Menge für {value0} {value1}",
  "Quantity saved for {value0}.": "Menge für {value0} gespeichert.",
  "Read-only access": "Lesezugriff",
  "Reason for correction": "Korrekturgrund",
  "Registered variant": "Registrierte Variante",
  "Release": "Freigeben",
  "Release revision": "Revision freigeben",
  "Remove alias {value}": "Externe Nummer {value} entfernen",
  "Remove from assembly {value0} {value1}": "{value0} {value1} aus Baugruppe entfernen",
  "Remove selected occurrence": "Gewählte Verwendung entfernen",
  "Remove {value0}'s access": "Zugriff von {value0} entfernen",
  "Replace invitation link for {value0}": "Einladungslink für {value0} ersetzen",
  "Reset quantity for {value0}": "Menge für {value0} zurücksetzen",
  "Resolved definition: REV": "Aufgelöste Definition: REV",
  "Results: {count}": "Ergebnisse: {count}",
  "Retry preview": "Vorschau erneut laden",
  "Revoke": "Widerrufen",
  "Revoke invitation for {value0}": "Einladung für {value0} widerrufen",
  "Right": "Rechts",
  "Role": "Rolle",
  "Same family number, different identities.": "Gleiche Familiennummer, verschiedene Identitäten.",
  "Save quantity for {value0}": "Menge für {value0} speichern",
  "Search pages": "Suchseiten",
  "Source product version": "Quellproduktversion",
  "Source project": "Quellprojekt",
  "Start from": "Beginnen mit",
  "Structural class": "Bauart",
  "The invitation was created, but its one-time link cannot be shown again. Use Replace link to generate another.": "Einladung erstellt, einmaliger Link nicht erneut abrufbar. Erzeugen Sie mit „Link ersetzen“ einen neuen.",
  "This invitation link is incomplete. Ask the company owner for a replacement link.": "Einladungslink unvollständig. Bitten Sie den Firmeneigentümer um einen Ersatzlink.",
  "This part is not used in a structure or configuration.": "Dieses Teil wird in keiner Struktur oder Konfiguration verwendet.",
  "This structure is read-only. Choose a draft revision to edit.": "Diese Struktur ist schreibgeschützt. Wählen Sie eine Entwurfsrevision zum Bearbeiten.",
  "Unit & position": "Einheit und Position",
  "Unit for occurrence {value0}": "Einheit der Verwendung {value0}",
  "Unspecified": "Nicht angegeben",
  "Unused assignments are corrected directly. Controlled identities are renamed atomically with historical redirects; revisions, configurations, and usage references stay attached.": "Unbenutzte Zuordnungen werden direkt korrigiert. Kontrollierte Identitäten werden atomar mit historischen Weiterleitungen umbenannt; Revisionen, Konfigurationen und Verwendungen bleiben verbunden.",
  "Use product-version root": "Produktversionswurzel verwenden",
  "Variant": "Variante",
  "Versions": "Versionen",
  "You do not have company access yet. Open an invitation from a company owner.": "Noch kein Firmenzugriff. Öffnen Sie eine Einladung eines Eigentümers.",
  "Your account does not have access to this company.": "Ihr Konto hat keinen Zugriff auf diese Firma.",
  "and its selected exact child revisions? The assembly and every child revision must already be released.": "und ihre gewählten genauen Unterteilrevisionen? Baugruppe und alle Unterteile müssen bereits freigegeben sein.",
  "as": "als",
  "because the new cover was explicitly numbered as related to the existing one.": "weil die neue Abdeckung ausdrücklich als verwandt nummeriert wurde.",
  "may replace": "kann ersetzen",
  "using": "mit",
  "· Expires": "· Läuft ab",
  "Sign in again": "Erneut anmelden",
  "Refresh session": "Sitzung erneuern",
  "Connection interrupted. Check the saved change before making another edit.": "Verbindung unterbrochen. Prüfen Sie die gespeicherte Änderung vor weiterer Bearbeitung.",
  "The request could not be completed.": "Anfrage konnte nicht abgeschlossen werden.",
  "Resolve the saved change shown above before making another edit.": "Klären Sie die gespeicherte Änderung vor weiterer Bearbeitung.",
  "Browser storage is unavailable. Enable it before saving a change.": "Browserspeicher nicht verfügbar. Aktivieren Sie ihn vor dem Speichern.",
  "No position": "Keine Position",
  "Not specified.": "Nicht angegeben.",
  "No description.": "Keine Beschreibung.",
  "Field": "Feld",
  "Choose…": "Wählen…",
  "Choose": "Wählen",
  "Complete {field}.": "Füllen Sie {field} aus.",
  "Check the value of {field}.": "Prüfen Sie den Wert von {field}.",
  "Do not submit another edit until this change is confirmed.": "Keine weitere Änderung absenden, bis diese bestätigt ist.",
  "CFG1 keeps cover REV1; CFG2 selects cover REV2. A configuration is not a new part number and applies only to assemblies.": "CFG1 behält Abdeckung REV1; CFG2 wählt REV2. Eine Konfiguration ist keine neue Teilenummer und gilt nur für Baugruppen.",
  "No variant": "Keine Variante",
  "Company created": "Firma erstellt",
  "Company updated": "Firma aktualisiert",
  "Variant code registered": "Variantencode registriert",
  "Position code registered": "Positionscode registriert",
  "Role changed": "Rolle geändert",
  "Membership removed": "Mitgliedschaft entfernt",
  "Invitation created": "Einladung erstellt",
  "Invitation link replaced": "Einladungslink ersetzt",
  "Invitation revoked": "Einladung widerrufen",
  "Invitation accepted": "Einladung angenommen",
  "Revision created": "Revision erstellt",
  "Revision definition updated": "Revisionsdefinition aktualisiert",
  "Revision released": "Revision freigegeben",
  "Structure occurrence added": "Teilverwendung hinzugefügt",
  "Structure occurrence updated": "Teilverwendung aktualisiert",
  "Structure occurrence removed": "Teilverwendung entfernt",
  "Configuration created": "Konfiguration erstellt",
  "Configuration updated": "Konfiguration aktualisiert",
  "Configuration released": "Konfiguration freigegeben",
  "Replacement recorded": "Ersatz erfasst",
  "Replacement withdrawn": "Ersatz zurückgezogen",
  "Project created": "Projekt erstellt",
  "Project updated": "Projekt aktualisiert",
  "Product version created": "Produktversion erstellt",
  "Product version updated": "Produktversion aktualisiert",
  "Part issued": "Teilenummer vergeben",
  "Part details updated": "Teiledetails aktualisiert",
  "alias-added": "Externe Nummer hinzugefügt",
  "alias-edited": "Externe Nummer geändert",
  "alias-removed": "Externe Nummer entfernt",
  "Identity renamed": "Identität umbenannt",
  "Assignment corrected": "Zuordnung korrigiert",
  "North": "Nord",
  "South": "Süd",
  "West": "West",
  "East": "Ost",
  "Front": "Vorne",
  "Rear": "Hinten",
  "Mid": "Mitte",
  "Top": "Oben",
  "Bottom": "Unten",
  "Side": "Seite",
  "North / south": "Nord / Süd",
  "West / east": "West / Ost",
  "Front / rear": "Vorne / hinten",
  "Top / bottom": "Oben / unten",
  "Custom": "Benutzerdefiniert",
  "Family, not an orderable P/N": "Familie, keine bestellbare P/N",
  "Pending": "Ausstehend",
  "Accepted": "Angenommen",
  "Revoked": "Widerrufen",
  "Expired": "Abgelaufen",
  "Edit revision definition": "Revisionsdefinition bearbeiten",
  "Release revision?": "Revision freigeben?",
  "Release configuration?": "Konfiguration freigeben?",
  "A complete SHA-256 checksum is required.": "Eine vollständige SHA-256-Prüfsumme ist erforderlich.",
  "Add comment": "Kommentar hinzufügen",
  "Add file": "Datei hinzufügen",
  "All": "Alle",
  "Applicability": "Anwendbarkeit",
  "Applicability must refer to a configuration of the owning part.": "Die Anwendbarkeit muss auf eine Konfiguration des Teils verweisen, zu dem das Dokument gehört.",
  "Applicability must refer to a revision of the owning part.": "Die Anwendbarkeit muss auf eine Revision des Teils verweisen, zu dem das Dokument gehört.",
  "Applicability notes": "Hinweise zur Anwendbarkeit",
  "Attachment": "Anhang",
  "Cancel upload": "Upload abbrechen",
  "Cancelled": "Abgebrochen",
  "Checking file…": "Datei wird geprüft…",
  "Choose Draft or Issued status.": "Wählen Sie den Status „Entwurf“ oder „Freigegeben“.",
  "Choose Source, Rendition or Attachment.": "Wählen Sie „Quelldatei“, „Darstellungsversion“ oder „Anhang“.",
  "Choose a draft document or production job for this file.": "Wählen Sie einen Dokumententwurf oder Fertigungsauftrag für diese Datei.",
  "Choose a file of this revision.": "Wählen Sie eine Datei dieser Revision.",
  "Choose a registered document type.": "Wählen Sie einen registrierten Dokumenttyp.",
  "Choose a supported document owner.": "Wählen Sie einen unterstützten Dokumenteigentümer.",
  "Choose a valid results page and a positive page size.": "Wählen Sie eine gültige Ergebnisseite und eine positive Anzahl von Ergebnissen pro Seite.",
  "Choose an issued revision of this document.": "Wählen Sie eine freigegebene Revision dieses Dokuments.",
  "Choose the viewed revision of this document.": "Wählen Sie die angezeigte Revision dieses Dokuments.",
  "Choose this company as the document owner.": "Wählen Sie dieses Unternehmen als Dokumenteigentümer.",
  "Clear applicability references": "Anwendbarkeitsreferenzen löschen",
  "Comment": "Kommentar",
  "Comment history": "Kommentarverlauf",
  "Comment removed": "Kommentar entfernt",
  "Copy this revision into a shared editable draft?": "Diese Revision in einen gemeinsam bearbeitbaren Entwurf kopieren?",
  "Create document": "Dokument erstellen",
  "Create shared draft": "Gemeinsamen Entwurf erstellen",
  "Deleted comments retain their history and cannot be edited.": "Gelöschte Kommentare behalten ihren Verlauf und können nicht bearbeitet werden.",
  "Discussion": "Diskussion",
  "Document comment added": "Dokumentkommentar hinzugefügt",
  "Document comment deleted": "Dokumentkommentar gelöscht",
  "Document comment edited": "Dokumentkommentar bearbeitet",
  "Document created": "Dokument erstellt",
  "Document draft created": "Dokumententwurf erstellt",
  "Document draft updated": "Dokumententwurf aktualisiert",
  "Document file": "Dokumentdatei",
  "Document file linked": "Datei mit Dokument verknüpft",
  "Document file unlinked": "Dateiverknüpfung zum Dokument entfernt",
  "Document files published": "Dokumentdateien veröffentlicht",
  "Document files unpublished": "Veröffentlichung der Dokumentdateien aufgehoben",
  "Document information": "Dokumentinformationen",
  "Document issued": "Dokument freigegeben",
  "Document number": "Dokumentnummer",
  "Document reader": "Dokumentansicht",
  "Document type": "Dokumenttyp",
  "Document type registered": "Dokumenttyp registriert",
  "Documents": "Dokumente",
  "Download {name}": "{name} herunterladen",
  "Edit comment": "Kommentar bearbeiten",
  "Edit draft": "Entwurf bearbeiten",
  "Edit history": "Bearbeitungsverlauf",
  "Exact engineering applicability": "Genaue technische Anwendbarkeit",
  "Exact revision": "Genaue Revision",
  "File": "Datei",
  "File name": "Dateiname",
  "File purpose": "Dateizweck",
  "File size must be between 1 byte and 20 GiB.": "Die Dateigröße muss zwischen 1 Byte und 20 GiB liegen.",
  "File storage is not configured.": "Der Dateispeicher ist nicht konfiguriert.",
  "File unavailable": "Datei nicht verfügbar",
  "Files": "Dateien",
  "Files available to anyone with the public link": "Dateien sind für alle mit dem öffentlichen Link verfügbar",
  "Files can only be added to a draft document.": "Dateien können nur zu einem Dokumententwurf hinzugefügt werden.",
  "Identifier filter": "Kennungsfilter",
  "Issue revision": "Revision freigeben",
  "Issue this exact revision? Its metadata and files will become immutable.": "Genau diese Revision freigeben? Ihre Metadaten und Dateien können danach nicht mehr geändert werden.",
  "Issued": "Freigegeben",
  "Issued revisions are immutable. Create a shared draft to make changes.": "Freigegebene Revisionen sind unveränderlich. Erstellen Sie für Änderungen einen gemeinsamen Entwurf.",
  "Link at least one verified file before issuing.": "Verknüpfen Sie vor der Freigabe mindestens eine verifizierte Datei.",
  "New file": "Neue Datei",
  "No comments yet.": "Noch keine Kommentare.",
  "No files in this revision.": "Diese Revision enthält keine Dateien.",
  "No published files.": "Keine veröffentlichten Dateien.",
  "No revisions available.": "Keine Revisionen verfügbar.",
  "Only an unfinished upload can be cancelled.": "Nur ein noch nicht abgeschlossener Upload kann abgebrochen werden.",
  "Only issued files can be published.": "Nur freigegebene Dateien können veröffentlicht werden.",
  "Only length- and SHA-256-verified immutable files can be linked or issued.": "Nur unveränderliche Dateien mit verifizierter Länge und SHA-256-Prüfsumme können verknüpft oder freigegeben werden.",
  "Open public link": "Öffentlichen Link öffnen",
  "Owner kind": "Eigentümertyp",
  "Page {page} · {count} documents": "Seite {page} · Dokumente: {count}",
  "Part revision": "Teilrevision",
  "Pause": "Pausieren",
  "Paused": "Pausiert",
  "Preview is not available for this file. Download it instead.": "Für diese Datei ist keine Vorschau verfügbar. Laden Sie sie stattdessen herunter.",
  "Preview unavailable. Download the file to view it.": "Vorschau nicht verfügbar. Laden Sie die Datei herunter, um sie anzusehen.",
  "Public description": "Öffentliche Beschreibung",
  "Public links": "Öffentliche Links",
  "Public title": "Öffentlicher Titel",
  "Publication not found.": "Veröffentlichung nicht gefunden.",
  "Publish selected files": "Ausgewählte Dateien veröffentlichen",
  "Published document not found.": "Veröffentlichtes Dokument nicht gefunden.",
  "Published file not found.": "Veröffentlichte Datei nicht gefunden.",
  "Register document type": "Dokumenttyp registrieren",
  "Reload revision": "Revision neu laden",
  "Remove comment": "Kommentar entfernen",
  "Remove file": "Datei entfernen",
  "Remove this comment? Its edit history is retained.": "Diesen Kommentar entfernen? Sein Bearbeitungsverlauf bleibt erhalten.",
  "Remove this file from the draft? Earlier issued revisions keep their files.": "Diese Datei aus dem Entwurf entfernen? Frühere freigegebene Revisionen behalten ihre Dateien.",
  "Remove {name}": "{name} entfernen",
  "Rendition": "Darstellungsversion",
  "Resume this upload with the recorder who started it.": "Setzen Sie diesen Upload mit dem Erfasser fort, der ihn gestartet hat.",
  "Resume upload": "Upload fortsetzen",
  "Revision unavailable": "Revision nicht verfügbar",
  "Revision {number}": "Revision {number}",
  "Revision {number} · {status}": "Revision {number} · {status}",
  "SHA-256": "SHA-256",
  "Search documents": "Dokumente suchen",
  "Select distinct issued files to publish.": "Wählen Sie unterschiedliche freigegebene Dateien zur Veröffentlichung.",
  "Select files from this exact issued revision.": "Wählen Sie Dateien aus genau dieser freigegebenen Revision.",
  "Select the same file to resume this upload.": "Wählen Sie dieselbe Datei, um diesen Upload fortzusetzen.",
  "Source": "Quelldatei",
  "Status": "Status",
  "Stop subsequent access through this public link? Already downloaded copies are not removed.": "Künftigen Zugriff über diesen öffentlichen Link sperren? Bereits heruntergeladene Kopien werden nicht entfernt.",
  "That document revision was not found in this company.": "Diese Dokumentrevision wurde in diesem Unternehmen nicht gefunden.",
  "The configuration must select the exact applicability revision.": "Die Konfiguration muss genau die für die Anwendbarkeit angegebene Revision auswählen.",
  "The document input changed during capture. Retry the same request.": "Die Dokumenteingaben haben sich während der Erfassung geändert. Wiederholen Sie dieselbe Anfrage.",
  "The file upload is not complete.": "Der Datei-Upload ist nicht abgeschlossen.",
  "The issued files no longer match their immutable manifest.": "Die freigegebenen Dateien stimmen nicht mehr mit ihrem unveränderlichen Manifest überein.",
  "The issued manifest failed integrity verification.": "Die Integritätsprüfung des freigegebenen Manifests ist fehlgeschlagen.",
  "The uploaded file checksum does not match. Cancel this upload and select the original file again.": "Die Prüfsumme der hochgeladenen Datei stimmt nicht überein. Brechen Sie diesen Upload ab und wählen Sie die Originaldatei erneut aus.",
  "The uploaded file is unavailable.": "Die hochgeladene Datei ist nicht verfügbar.",
  "The verified file must belong to this document.": "Die verifizierte Datei muss zu diesem Dokument gehören.",
  "This comment is already deleted.": "Dieser Kommentar wurde bereits gelöscht.",
  "This document already has a shared draft.": "Dieses Dokument hat bereits einen gemeinsamen Entwurf.",
  "This document numbering sequence is exhausted.": "Diese Dokumentnummernfolge ist ausgeschöpft.",
  "This file is not available.": "Diese Datei ist nicht verfügbar.",
  "This file is unavailable. Contact the company owner.": "Diese Datei ist nicht verfügbar. Wenden Sie sich an den Unternehmenseigentümer.",
  "This revision changed. Reload it before publishing.": "Diese Revision wurde geändert. Laden Sie sie vor der Veröffentlichung neu.",
  "This upload cannot be verified.": "Dieser Upload kann nicht verifiziert werden.",
  "This upload is no longer writable.": "In diesen Upload können keine weiteren Daten geschrieben werden.",
  "This upload was not found.": "Dieser Upload wurde nicht gefunden.",
  "Title": "Titel",
  "Title filter": "Titelfilter",
  "Type code": "Typcode",
  "Type name": "Typname",
  "Unpublish": "Veröffentlichung aufheben",
  "Unpublished": "Veröffentlichung aufgehoben",
  "Upload file": "Datei hochladen",
  "Uploaded": "Hochgeladen",
  "Uploading…": "Wird hochgeladen…",
  "Use a file name without a path or control characters.": "Verwenden Sie einen Dateinamen ohne Pfad oder Steuerzeichen.",
  "Use a file name without directory separators.": "Verwenden Sie einen Dateinamen ohne Verzeichnistrennzeichen.",
  "Use an uppercase alphanumeric type code starting with a letter.": "Verwenden Sie einen Typcode aus lateinischen Großbuchstaben und Ziffern, der mit einem Buchstaben beginnt.",
  "Verified": "Verifiziert",
  "Verifying file…": "Datei wird verifiziert…",
  "View draft": "Entwurf ansehen",
  "file-upload-created": "Datei-Upload angelegt",
  "file-verified": "Datei verifiziert",
  "{bytes} bytes": "{bytes} Byte",
  "No matching documents.": "Keine passenden Dokumente.",
  "No documents yet.": "Noch keine Dokumente.",
  "The revision’s applicability details could not be loaded. Try again.": "Die Anwendbarkeitsdetails der Revision konnten nicht geladen werden. Versuchen Sie es erneut.",
  "Comment authors could not be loaded. Try again.": "Die Kommentarautoren konnten nicht geladen werden. Versuchen Sie es erneut.",
  "Comment history authors could not be loaded. Try again.": "Die Autoren im Kommentarverlauf konnten nicht geladen werden. Versuchen Sie es erneut.",
  "Choose a saved search": "Gespeicherte Suche auswählen",
  "This saved search belongs to another person or collection.": "Diese gespeicherte Suche gehört zu einer anderen Person oder Sammlung.",
  "Choose a saved parts search.": "Wählen Sie eine gespeicherte Teilesuche.",
  "Supply document search filters.": "Geben Sie Filter für die Dokumentensuche an.",
  "Pages": "Seiten",
  "{from}–{to} of {total}": "{from}–{to} von {total}",
  "Choose lot": "Charge auswählen",
  "Choose material": "Werkstoff auswählen",
  "No matches": "Keine Treffer",
  "Stock": "Lagerbestand",
  "Lots": "Chargen",
  "Materials": "Werkstoffe",
  "Supplier": "Lieferant",
  "Material identifier": "Werkstoffkennung",
  "Specification": "Spezifikation",
  "Reload latest versions": "Aktuelle Versionen neu laden",
  "Edit material": "Werkstoff bearbeiten",
  "Create material revision": "Werkstoffrevision erstellen",
  "Edit material revision": "Werkstoffrevision bearbeiten",
  "Release material revision": "Werkstoffrevision freigeben",
  "Create lot": "Charge erstellen",
  "Choose an exact material revision.": "Wählen Sie eine bestimmte Werkstoffrevision.",
  "Lot identifier": "Chargenkennung",
  "Balances": "Bestände",
  "No stock recorded": "Kein Bestand erfasst",
  "Genealogy": "Chargenherkunft",
  "No linked lots": "Keine verknüpften Chargen",
  "To": "Nach",
  "Reversed": "Storniert",
  "Movement details": "Buchungsdetails",
  "Record history": "Datensatzverlauf",
  "Movements": "Lagerbewegungen",
  "Movement type": "Bewegungsart",
  "No movements recorded": "Keine Bewegungen erfasst",
  "Original movement": "Ursprüngliche Buchung",
  "Replaced movement": "Ersetzte Buchung",
  "Reversal": "Stornierung",
  "Reverse movement": "Buchung stornieren",
  "Record replacement": "Ersatz erfassen",
  "Movement warnings unavailable": "Bewegungswarnungen nicht verfügbar",
  "Warnings": "Warnungen",
  "Actual quantity": "Istmenge",
  "Location": "Lagerort",
  "Disposition": "Verwendungsstatus",
  "Use balance location": "Lagerort des Bestands verwenden",
  "Wait for the latest balances.": "Warten Sie auf die aktuellen Bestände.",
  "Choose a lot for every quantity.": "Wählen Sie für jede Menge eine Charge.",
  "Source {number}": "Quelle {number}",
  "Remove source": "Quelle entfernen",
  "Add source": "Quelle hinzufügen",
  "Output {number}": "Ausgang {number}",
  "Remove output": "Ausgang entfernen",
  "Add output": "Ausgang hinzufügen",
  "Destination location": "Ziellagerort",
  "Source reference": "Quellreferenz",
  "Reason": "Grund",
  "Reload latest balances": "Aktuelle Bestände neu laden",
  "Receipt": "Wareneingang",
  "Accept": "Annehmen",
  "Quarantine": "Sperren",
  "Transfer": "Umlagerung",
  "Consume": "Verbrauchen",
  "Scrap": "Verschrotten",
  "Split": "Aufteilen",
  "Merge": "Zusammenführen",
  "MaterialLots": "Werkstoffchargen",
  "Receipts": "Wareneingänge",
  "Create material": "Werkstoff erstellen",
  "Search lots": "Chargen suchen",
  "Search materials": "Werkstoffe suchen",
  "Select a lot": "Wählen Sie eine Charge",
  "Select a material": "Wählen Sie ein Werkstoff",
  "Supplier reference": "Lieferantenreferenz",
  "Supplier lot reference": "Lieferantenchargennummer",
  "Material created": "Werkstoff erstellt",
  "Material renamed": "Werkstoff umbenannt",
  "Material revision created": "Werkstoffrevision erstellt",
  "Material revision edited": "Werkstoffrevision bearbeitet",
  "Material revision released": "Werkstoffrevision freigegeben",
  "Lot created": "Charge erstellt",
  "Correction": "Korrektur",
  "Record updated": "Datensatz aktualisiert",
  "All movements": "Alle Lagerbewegungen",
  "Quarantined": "Gesperrt",
  "Not recorded": "Nicht erfasst",
  "No matching records.": "Keine passenden Datensätze.",
  "Page": "Seite",
  "Evidence warnings": "Nachweiswarnungen",
  "Production": "Produktion",
  "Create job": "Fertigungsauftrag erstellen",
  "Routes": "Arbeitspläne",
  "Search jobs": "Fertigungsaufträge suchen",
  "Clear part filter": "Teilefilter zurücksetzen",
  "No jobs found.": "Keine Fertigungsaufträge gefunden.",
  "Select a job to review or record actual work.": "Wählen Sie einen Auftrag, um tatsächliche Arbeiten zu prüfen oder zu erfassen.",
  "Change": "Ändern",
  "Select an exact definition revision.": "Wählen Sie eine bestimmte Definitionsrevision.",
  "Job identifier": "Auftragskennung",
  "Route input": "Arbeitsplan als Eingabe",
  "Document inputs": "Eingabedokumente",
  "Select route": "Arbeitsplan auswählen",
  "Back": "Zurück",
  "Create route": "Arbeitsplan erstellen",
  "Create route revision": "Arbeitsplanrevision erstellen",
  "Choose another route": "Anderen Arbeitsplan auswählen",
  "Inspection expected": "Prüfung vorgesehen",
  "Route name": "Arbeitsplanname",
  "Operation": "Arbeitsgang",
  "Instructions": "Anweisungen",
  "Move up": "Nach oben",
  "Move down": "Nach unten",
  "Remove operation": "Arbeitsgang entfernen",
  "Add operation": "Arbeitsgang hinzufügen",
  "Serials": "Serialisierte Einheiten",
  "ProductionOutputs": "Fertigungsergebnisse",
  "Operations": "Arbeitsgänge",
  "Inspections": "Prüfungen",
  "Declarations": "Erklärungen",
  "Back to collection": "Zurück zur Liste",
  "Recorded at": "Erfasst am",
  "Created": "Erstellt",
  "Display columns": "Spalten anzeigen",
  "Import records": "Datensätze importieren",
  "Preview records": "Datensätze voranzeigen",
  "New preview": "Neue Vorschau",
  "Apply valid rows": "Gültige Zeilen übernehmen",
  "Reload preview": "Vorschau neu laden",
  "Row {number}": "Zeile {number}",
  "Applied": "Übernommen",
  "Apply row": "Zeile übernehmen",
  "Source name": "Quellname",
  "Record type": "Datensatztyp",
  "Download CSV template": "CSV-Vorlage herunterladen",
  "CSV file": "CSV-Datei",
  "Previous imports": "Frühere Importe",
  "Manual entry": "Manuelle Eingabe",
  "Choose a CSV file.": "Wählen Sie eine CSV-Datei.",
  "The CSV file exceeds the import size limit.": "Die CSV-Datei überschreitet die Importgrößenbegrenzung.",
  "Serial number": "Seriennummer",
  "Output source reference": "Quellreferenz des Ergebnisses",
  "Step": "Schritt",
  "Result": "Ergebnis",
  "Actual result": "Istergebnis",
  "Kind": "Art",
  "Value": "Wert",
  "Exact configuration": "Bestimmte Konfiguration",
  "Exact route revision": "Bestimmte Arbeitsplanrevision",
  "Material definition": "Werkstoffdefinition",
  "Primary definition": "Primärdefinition",
  "Route revision": "Arbeitsplanrevision",
  "Record output": "Ergebnis erfassen",
  "Record operation": "Arbeitsgang erfassen",
  "Record inspection": "Prüfung erfassen",
  "Record consumption or component": "Verbrauch oder Komponente erfassen",
  "Declare output": "Ergebnisstatus erklären",
  "Capture as-built": "Ist-Konfiguration erfassen",
  "Unnamed record": "Unbenannter Datensatz",
  "Serial": "Seriennummer",
  "None available": "Keine verfügbar",
  "The selected job was not found in an editable company.": "Der ausgewählte Auftrag wurde in keiner bearbeitbaren Firma gefunden.",
  "Offline job": "Offline-Auftrag",
  "Download selected job": "Ausgewählten Auftrag herunterladen",
  "Offline work": "Offline-Arbeit",
  "Selected job and files saved for offline use.": "Ausgewählter Auftrag und Dateien sind zur Offline-Nutzung gespeichert.",
  "Download": "Herunterladen",
  "bytes": "Bytes",
  "Find material lots": "Werkstoffchargen suchen",
  "Find component parts": "Komponententeile suchen",
  "Correct recorded work": "Erfasste Arbeit korrigieren",
  "Save correction": "Korrektur speichern",
  "Save offline": "Offline speichern",
  "Wait for evidence to finish saving.": "Warten Sie, bis die Nachweise gespeichert sind.",
  "Choose an output with a recorded version.": "Wählen Sie ein Ergebnis mit erfasster Version.",
  "Reconnect and load current records before saving a correction.": "Verbinden Sie sich erneut und laden Sie aktuelle Datensätze, bevor Sie eine Korrektur speichern.",
  "Confirm that this correction uses the current stock version.": "Bestätigen Sie, dass diese Korrektur die aktuelle Bestandsversion verwendet.",
  "The original recording is retained. Review current records before submitting a separate correction.": "Die ursprüngliche Aufzeichnung bleibt erhalten. Prüfen Sie aktuelle Datensätze, bevor Sie eine separate Korrektur einreichen.",
  "Loading current records": "Aktuelle Datensätze werden geladen",
  "Current stock": "Aktueller Bestand",
  "Completed": "Abgeschlossen",
  "Failed": "Fehlgeschlagen",
  "Skipped": "Übersprungen",
  "InProgress": "In Bearbeitung",
  "Passed": "Bestanden",
  "Inconclusive": "Nicht eindeutig",
  "I reviewed the stock conflict and authorize this correction against current stock.": "Ich habe den Bestandskonflikt geprüft und genehmige diese Korrektur auf Grundlage des aktuellen Bestands.",
  "Quality": "Qualität",
  "NotStarted": "Nicht begonnen",
  "Rejected": "Abgelehnt",
  "As-built": "Ist-Konfiguration",
  "Evidence file": "Nachweisdatei",
  "Saving evidence locally": "Nachweise werden lokal gespeichert",
  "The correction retains the original evidence attachments.": "Die Korrektur behält die ursprünglichen Nachweisanlagen bei.",
  "Reconnect to verify recorder access before continuing.": "Verbinden Sie sich erneut, um vor dem Fortfahren den Zugriff der erfassenden Person zu prüfen.",
  "Reconnect as the original offline recorder.": "Verbinden Sie sich als die ursprünglich offline erfassende Person erneut.",
  "Offline recording access was revoked. Recorded work is retained.": "Der Zugriff zur Offline-Erfassung wurde entzogen. Erfasste Arbeit bleibt erhalten.",
  "Reconnect": "Erneut verbinden",
  "Loading": "Wird geladen",
  "No offline job is open. Download a selected production job while connected.": "Kein Offline-Auftrag ist geöffnet. Laden Sie bei bestehender Verbindung einen ausgewählten Fertigungsauftrag herunter.",
  "Selected job": "Ausgewählter Auftrag",
  "Online": "Online",
  "Offline": "Offline",
  "Resume download": "Download fortsetzen",
  "Synchronize": "Synchronisieren",
  "Close offline session": "Offline-Sitzung schließen",
  "Captured operations": "Gesicherte Arbeitsgänge",
  "No route captured": "Kein Arbeitsplan gesichert",
  "Recorded inspections": "Erfasste Prüfungen",
  "Outputs": "Ergebnisse",
  "No outputs recorded": "Keine Ergebnisse erfasst",
  "Downloaded files": "Heruntergeladene Dateien",
  "Material lots": "Werkstoffchargen",
  "Record work": "Arbeit erfassen",
  "Recorded commands": "Erfasste Aktionen",
  "No local commands recorded": "Keine lokalen Aktionen erfasst",
  "Retained original; correction recorded": "Original beibehalten; Korrektur erfasst",
  "Retry unchanged": "Unverändert wiederholen",
  "Saved evidence": "Gespeicherte Nachweise",
  "Close only after all recorded work and evidence are accepted. Local history remains available.": "Schließen Sie erst, wenn alle erfassten Arbeiten und Nachweise angenommen wurden. Der lokale Verlauf bleibt verfügbar.",
  "Offline storage is unavailable in this browser.": "Offline-Speicher ist in diesem Browser nicht verfügbar.",
  "The offline application could not be downloaded. Try again online.": "Die Offline-Anwendung konnte nicht heruntergeladen werden. Versuchen Sie es online erneut.",
  "The offline application is not ready. Reload online and try again.": "Die Offline-Anwendung ist nicht bereit. Laden Sie online neu und versuchen Sie es erneut.",
  "An offline update is waiting. Close other registry tabs and reload online.": "Ein Offline-Update wartet. Schließen Sie andere Register-Tabs und laden Sie online neu.",
  "Verified files": "Verifizierte Dateien",
  "Component part": "Komponententeil",
  "Component serials": "Serialisierte Komponenten",
  "Output": "Ergebnis",
  "Reserved serial": "Reservierte serialisierte Einheit",
  "Output lot": "Ergebnischarge",
  "Operation order": "Arbeitsgangreihenfolge",
  "Shared run": "Gemeinsamer Fertigungslauf",
  "Rework of": "Nacharbeit zu",
  "Inspection": "Prüfung",
  "Actual": "Istwert",
  "Operation attempt": "Arbeitsgangversuch",
  "Material lot": "Werkstoffcharge",
  "Component serial": "Serialisierte Komponente",
  "Actual revision": "Tatsächliche Revision",
  "Declaration": "Erklärung",
  "Declared state": "Erklärter Zustand",
  "Amends snapshot": "Korrigiert Momentaufnahme",
  "Attach saved evidence": "Gespeicherte Nachweise anhängen",
  "preparing": "Wird vorbereitet",
  "downloading": "Wird heruntergeladen",
  "ready": "Bereit",
  "rejected": "Abgelehnt",
  "closed": "Geschlossen",
  "pending": "Ausstehend",
  "sending": "Wird gesendet",
  "accepted": "Angenommen",
  "conflict": "Konflikt",
  "staged": "Lokal vorgemerkt",
  "uploading": "Wird hochgeladen",
  "verified": "Verifiziert",
  "attached": "Angehängt",
  "Captured inputs": "Gesicherte Eingaben",
  "Captured route": "Gesicherter Arbeitsplan",
  "Planned components": "Geplante Komponenten",
  "No planned components.": "Keine geplanten Komponenten.",
  "No file evidence recorded.": "Keine Dateinachweise erfasst.",
  "Evidence files": "Nachweisdateien",
  "Actual outputs": "Tatsächliche Ergebnisse",
  "No actual outputs recorded.": "Keine tatsächlichen Ergebnisse erfasst.",
  "Operations and inspections": "Arbeitsgänge und Prüfungen",
  "Create shared run": "Gemeinsamen Fertigungslauf erstellen",
  "Record rework": "Nacharbeit erfassen",
  "No operations or inspections recorded.": "Keine Arbeitsgänge oder Prüfungen erfasst.",
  "Actual components and lots": "Tatsächliche Komponenten und Chargen",
  "Record component or lot": "Komponente oder Charge erfassen",
  "No actual components recorded.": "Keine tatsächlichen Komponenten erfasst.",
  "Job documents": "Auftragsdokumente",
  "Whole job": "Gesamter Auftrag",
  "Actual component": "Tatsächliche Komponente",
  "Unserialized output": "Nicht serialisiertes Ergebnis",
  "Not declared": "Nicht erklärt",
  "Declare production": "Produktionsstatus erklären",
  "Declare quality": "Qualitätsstatus erklären",
  "Amend as-built": "Ist-Konfiguration korrigieren",
  "Declaration history": "Erklärungsverlauf",
  "As-built history": "Verlauf der Ist-Konfiguration",
  "Snapshot": "Momentaufnahme",
  "Choose a declaration.": "Wählen Sie eine Erklärung.",
  "As-built snapshot": "Momentaufnahme der Ist-Konfiguration",
  "Actual output": "Tatsächliches Ergebnis",
  "No serialized units found.": "Keine serialisierten Einheiten gefunden.",
  "Serialized output": "Serialisiertes Ergebnis",
  "Clear": "Leeren",
  "Choose a result.": "Wählen Sie ein Ergebnis.",
  "Inspection name": "Prüfungsname",
  "Use shared run": "Gemeinsamen Fertigungslauf verwenden",
  "This job is not part of this shared run.": "Dieser Auftrag gehört nicht zu diesem gemeinsamen Fertigungslauf.",
  "Choose another run": "Anderen Fertigungslauf auswählen",
  "Run identifier": "Fertigungslaufkennung",
  "Serialized unit": "Serialisierte Einheit",
  "Select the actual component or lot.": "Wählen Sie die tatsächliche Komponente oder Charge.",
  "Serial units": "Serialisierte Einheiten",
  "Allocate serials": "Seriennummern zuweisen",
  "Import serial labels": "Serienkennzeichnungen importieren",
  "Void": "Ungültig machen",
  "Void serial": "Seriennummer ungültig machen",
  "Reprint label": "Etikett erneut drucken",
  "Enter positive integer serial numbers.": "Geben Sie positive ganze Zahlen als Seriennummern ein.",
  "Number of serials": "Anzahl der Seriennummern",
  "Existing serial numbers": "Vorhandene Seriennummern",
  "Serial label": "Serienetikett",
  "Allow pop-ups to print this label.": "Erlauben Sie Pop-ups, um dieses Etikett zu drucken.",
  "Print label": "Etikett drucken",
  "Lot {lot} uses draft material revision {revision}.": "Charge {lot} verwendet den Entwurf der Werkstoffrevision {revision}.",
  "Consumed quarantined stock: {lot}.": "Gesperrter Bestand verbraucht: {lot}.",
  "Insufficient stock: {lot} at {location} ({disposition}); available {available}, recorded outgoing {outgoing}.": "Unzureichender Bestand: {lot} in {location} ({disposition}); verfügbar {available}, erfasster Abgang {outgoing}.",
  "syncing": "Wird synchronisiert",
  "Supply the selected template's values.": "Geben Sie die Werte der ausgewählten Vorlage an.",
  "Manual intake contains an unknown column.": "Die manuelle Eingabe enthält eine unbekannte Spalte.",
  "A manual value is missing or too long.": "Ein manuell eingegebener Wert fehlt oder ist zu lang.",
  "Supply CSV text.": "Geben Sie CSV-Text an.",
  "Supply CSV text of at most 1 MiB.": "Geben Sie CSV-Text mit höchstens 1 MiB an.",
  "CSV text cannot contain null characters.": "CSV-Text darf keine Nullzeichen enthalten.",
  "CSV exceeds the 1 MiB UTF-8 limit.": "CSV überschreitet die UTF-8-Grenze von 1 MiB.",
  "CSV must contain valid UTF-8 text.": "CSV muss gültigen UTF-8-Text enthalten.",
  "The CSV header is missing.": "Die CSV-Kopfzeile fehlt.",
  "Every header must be unique.": "Jede Spaltenüberschrift muss eindeutig sein.",
  "The template requires this header, even when its values are optional.": "Die Vorlage erfordert diese Überschrift, auch wenn ihre Werte optional sind.",
  "This column is not in the selected template.": "Diese Spalte gehört nicht zur ausgewählten Vorlage.",
  "CSV contains more than 500 data rows.": "CSV enthält mehr als 500 Datenzeilen.",
  "This row must have exactly the number of fields in the header.": "Diese Zeile muss genau so viele Felder wie die Kopfzeile enthalten.",
  "Malformed CSV quoting or a field exceeds the 16,000-character limit. Correct the source and create a new preview.": "Fehlerhafte CSV-Anführungszeichen oder ein Feld überschreitet 16.000 Zeichen. Korrigieren Sie die Quelle und erstellen Sie eine neue Vorschau.",
  "A source reference may occur only once in a preview.": "Eine Quellreferenz darf in einer Vorschau nur einmal vorkommen.",
  "Supply at least one data row.": "Geben Sie mindestens eine Datenzeile an.",
  "This preview uses an older intake contract. Create a new preview.": "Diese Vorschau verwendet ältere Importregeln. Erstellen Sie eine neue Vorschau.",
  "The selected row does not match this immutable preview.": "Die ausgewählte Zeile stimmt nicht mit dieser unveränderlichen Vorschau überein.",
  "Correct the CSV errors and create a new preview before applying this row.": "Korrigieren Sie die CSV-Fehler und erstellen Sie eine neue Vorschau, bevor Sie diese Zeile übernehmen.",
  "This source row has already been applied with another payload or recorder. It cannot be overwritten.": "Diese Quellzeile wurde bereits mit anderen Daten oder durch eine andere Person übernommen. Sie kann nicht überschrieben werden.",
  "This row no longer meets the intake contract. Create a new preview.": "Diese Zeile entspricht nicht mehr den Importregeln. Erstellen Sie eine neue Vorschau.",
  "Referenced data changed after preview. Review the current data and create a new preview; this row was not rebased.": "Referenzierte Daten wurden nach der Vorschau geändert. Prüfen Sie die aktuellen Daten und erstellen Sie eine neue Vorschau; diese Zeile wurde nicht automatisch angepasst.",
  "No exact company reference matches this value.": "Keine genaue Referenz in dieser Firma entspricht diesem Wert.",
  "This reference is ambiguous; select an exact source reference.": "Diese Referenz ist mehrdeutig; wählen Sie eine genaue Quellreferenz.",
  "This material identifier already exists; intake does not overwrite definitions.": "Diese Werkstoffkennung existiert bereits; der Import überschreibt keine Definitionen.",
  "This lot identifier already exists; intake does not overwrite lots.": "Diese Chargenkennung existiert bereits; der Import überschreibt keine Chargen.",
  "Use the exact material revision unit.": "Verwenden Sie genau die Einheit der Werkstoffrevision.",
  "Use the exact authored lot unit; stock is not converted.": "Verwenden Sie genau die festgelegte Chargeneinheit; der Bestand wird nicht umgerechnet.",
  "The job must produce the exact selected part.": "Der Auftrag muss genau das ausgewählte Teil fertigen.",
  "This serial is already allocated or imported and cannot be reused.": "Diese Seriennummer wurde bereits zugewiesen oder importiert und kann nicht wiederverwendet werden.",
  "A serialized output is exactly one ea.": "Ein serialisiertes Ergebnis umfasst genau 1 ea.",
  "A part job cannot declare a material lot output.": "Ein Teileauftrag kann keine Werkstoffcharge als Ergebnis deklarieren.",
  "The operation must exist in the job's captured route.": "Der Arbeitsgang muss im gesicherten Arbeitsplan des Auftrags vorhanden sein.",
  "Select one actual output by its exact source reference.": "Wählen Sie ein tatsächliches Ergebnis anhand seiner genauen Quellreferenz.",
  "Use at most {maximum} characters.": "Verwenden Sie höchstens {maximum} Zeichen.",
  "A value is required.": "Ein Wert ist erforderlich.",
  "Use a positive, unpadded integer.": "Verwenden Sie eine positive ganze Zahl ohne führende Nullen.",
  "Use a positive decimal quantity, without grouping, with at most six fractional and twelve integer digits.": "Verwenden Sie eine positive Dezimalmenge ohne Zifferngruppierung mit höchstens sechs Nachkomma- und zwölf Vorkommastellen.",
  "Use an actual UTC timestamp such as 2026-09-07T12:30:00Z.": "Verwenden Sie einen tatsächlichen UTC-Zeitstempel wie 2026-09-07T12:30:00Z.",
  "Choose Accepted or Quarantined.": "Wählen Sie Accepted oder Quarantined.",
  "Choose Completed, Failed, Skipped or InProgress.": "Wählen Sie Completed, Failed, Skipped oder InProgress.",
  "Choose Passed, Failed or Inconclusive.": "Wählen Sie Passed, Failed oder Inconclusive.",
  "An imported serial requires its complete part PIN.": "Eine importierte Seriennummer benötigt die vollständige Teile-PIN.",
  "Choose Production or Quality.": "Wählen Sie Production oder Quality.",
  "Choose a declaration value belonging to this kind.": "Wählen Sie einen Erklärungswert, der zu dieser Art gehört.",
  "This intake preview was not found for this recorder and company.": "Diese Importvorschau wurde für diese erfassende Person und Firma nicht gefunden.",
  "This preview row was not found.": "Diese Vorschauzeile wurde nicht gefunden.",
  "Choose a published intake template.": "Wählen Sie eine veröffentlichte Importvorlage.",
  "Use an actual UTC timestamp.": "Verwenden Sie einen tatsächlichen UTC-Zeitstempel.",
  "This material identifier already exists.": "Diese Werkstoffkennung existiert bereits.",
  "Released or used definitions stay unchanged. Create a new revision.": "Freigegebene oder verwendete Definitionen bleiben unverändert. Erstellen Sie eine neue Revision.",
  "This material revision is already released.": "Diese Werkstoffrevision ist bereits freigegeben.",
  "Use the exact material revision unit; stock is not converted.": "Verwenden Sie genau die Einheit der Werkstoffrevision; der Bestand wird nicht umgerechnet.",
  "This lot identifier already exists.": "Diese Chargenkennung existiert bereits.",
  "This lot changed. Reload its balances before recording stock.": "Diese Charge wurde geändert. Laden Sie ihre Bestände neu, bevor Sie Bestand erfassen.",
  "Use the lot's exact authored unit; stock is not converted.": "Verwenden Sie genau die festgelegte Chargeneinheit; der Bestand wird nicht umgerechnet.",
  "Reverse the original movement before recording its replacement.": "Stornieren Sie die ursprüngliche Buchung, bevor Sie ihren Ersatz erfassen.",
  "This movement already has a replacement.": "Diese Buchung hat bereits einen Ersatz.",
  "This movement has already been corrected.": "Diese Buchung wurde bereits korrigiert.",
  "Use an exact location without surrounding whitespace.": "Geben Sie einen genauen Lagerort ohne umgebende Leerzeichen an.",
  "Split and merge require the same exact material revision.": "Aufteilen und Zusammenführen erfordern genau dieselbe Werkstoffrevision.",
  "Split and merge preserve disposition.": "Aufteilen und Zusammenführen erhalten den Verwendungsstatus.",
  "Split and merge quantities must match exactly.": "Die Mengen beim Aufteilen und Zusammenführen müssen genau übereinstimmen.",
  "This split or merge would create a cycle in the retained lot genealogy.": "Dieses Aufteilen oder Zusammenführen würde einen Zyklus in der gespeicherten Chargenherkunft erzeugen.",
  "Quantity must be positive with at most six decimal places and twelve integer digits.": "Die Menge muss positiv sein und darf höchstens sechs Nachkomma- und zwölf Vorkommastellen haben.",
  "Offline storage is unavailable. No local save was confirmed.": "Offline-Speicher ist nicht verfügbar. Eine lokale Speicherung wurde nicht bestätigt.",
  "Offline recording requires browser storage locking.": "Die Offline-Erfassung erfordert die Sperrfunktion des Browserspeichers.",
  "Offline storage could not save the change. Keep the original work and retry.": "Der Offline-Speicher konnte die Änderung nicht speichern. Behalten Sie die ursprüngliche Arbeit bei und versuchen Sie es erneut.",
  "Offline session not found.": "Offline-Sitzung nicht gefunden.",
  "Resolve the saved change shown above before synchronizing offline work.": "Klären Sie die oben angezeigte gespeicherte Änderung, bevor Sie Offline-Arbeit synchronisieren.",
  "This offline session is not the active recorder.": "Diese Offline-Sitzung ist nicht die aktive Erfassungssitzung.",
  "Offline file storage is unavailable in this browser.": "Offline-Dateispeicher ist in diesem Browser nicht verfügbar.",
  "Offline storage capacity cannot be checked.": "Die Offline-Speicherkapazität kann nicht geprüft werden.",
  "Not enough browser storage for the selected offline files.": "Nicht genügend Browserspeicher für die ausgewählten Offline-Dateien.",
  "Streaming downloads are unavailable.": "Streaming-Downloads sind nicht verfügbar.",
  "Choose one job and distinct offline files.": "Wählen Sie einen Auftrag und unterschiedliche Offline-Dateien.",
  "Choose distinct material lots and component units for offline use.": "Wählen Sie unterschiedliche Werkstoffchargen und Komponenteneinheiten zur Offline-Nutzung.",
  "Reconnect, resolve the active offline work and explicitly close it before switching recorder or job.": "Verbinden Sie sich erneut, klären Sie die aktive Offline-Arbeit und schließen Sie sie ausdrücklich ab, bevor Sie die erfassende Person oder den Auftrag wechseln.",
  "Finish preparation or closing before resolving offline work.": "Schließen Sie Vorbereitung oder Schließvorgang ab, bevor Sie Offline-Arbeit klären.",
  "Choose an unresolved conflicting or rejected command.": "Wählen Sie eine ungeklärte konfliktbehaftete oder abgelehnte Aktion.",
  "This offline session is not ready for new commands.": "Diese Offline-Sitzung ist nicht für neue Aktionen bereit.",
  "Choose distinct evidence staged in this offline session.": "Wählen Sie unterschiedliche, in dieser Offline-Sitzung vorgemerkte Nachweise.",
  "Only operation attempts and inspections support staged evidence.": "Nur Arbeitsgangversuche und Prüfungen unterstützen lokal vorgemerkte Nachweise.",
  "Upload and verify the referenced offline evidence before synchronizing this command.": "Laden Sie die referenzierten Offline-Nachweise hoch und verifizieren Sie sie, bevor Sie diese Aktion synchronisieren.",
  "Select at most 1000 evidence files.": "Wählen Sie höchstens 1000 Nachweisdateien.",
  "Finish preparation or closing before synchronizing.": "Schließen Sie Vorbereitung oder Schließvorgang vor der Synchronisierung ab.",
  "Finish preparation before synchronizing.": "Schließen Sie die Vorbereitung vor der Synchronisierung ab.",
  "The offline command response did not confirm acceptance.": "Die Antwort auf die Offline-Aktion hat deren Annahme nicht bestätigt.",
  "Upload and attach the staged offline evidence before closing. Local evidence is retained.": "Laden Sie die vorgemerkten Offline-Nachweise vor dem Schließen hoch und hängen Sie sie an. Lokale Nachweise bleiben erhalten.",
  "Resolve all pending, conflicting and rejected work before closing this offline session.": "Klären Sie alle ausstehenden, konfliktbehafteten und abgelehnten Arbeiten, bevor Sie diese Offline-Sitzung schließen.",
  "The server session was closed elsewhere. Review the retained local work.": "Die Serversitzung wurde andernorts geschlossen. Prüfen Sie die erhaltene lokale Arbeit.",
  "The server did not confirm closing this offline session.": "Der Server hat das Schließen dieser Offline-Sitzung nicht bestätigt.",
  "This file has not been downloaded and verified for offline use.": "Diese Datei wurde noch nicht zur Offline-Nutzung heruntergeladen und verifiziert.",
  "This offline session is not ready for new evidence.": "Diese Offline-Sitzung ist nicht für neue Nachweise bereit.",
  "Choose a nonempty evidence file and filename.": "Wählen Sie eine nicht leere Nachweisdatei und geben Sie einen Dateinamen an.",
  "This evidence has not been staged for offline use.": "Dieser Nachweis wurde nicht zur Offline-Nutzung vorgemerkt.",
  "Finish closing before updating evidence.": "Schließen Sie den Schließvorgang ab, bevor Sie Nachweise aktualisieren.",
  "Offline evidence changed. Read its current state before continuing.": "Offline-Nachweise wurden geändert. Prüfen Sie vor dem Fortfahren ihren aktuellen Zustand.",
  "Resume the original evidence upload.": "Setzen Sie den ursprünglichen Nachweis-Upload fort.",
  "The verified server file does not match the staged evidence.": "Die verifizierte Serverdatei stimmt nicht mit dem vorgemerkten Nachweis überein.",
  "This offline session belongs to another recorder.": "Diese Offline-Sitzung gehört einer anderen erfassenden Person.",
  "This offline session is closed. Its pending work cannot be submitted here.": "Diese Offline-Sitzung ist geschlossen. Ausstehende Arbeit kann hier nicht eingereicht werden.",
  "This command identity is already bound to different work. Keep the original command and record any correction separately.": "Diese Aktionskennung ist bereits mit anderer Arbeit verknüpft. Behalten Sie die ursprüngliche Aktion bei und erfassen Sie Korrekturen separat.",
  "Use a serial reserved for this job before the session was prepared.": "Verwenden Sie eine Seriennummer, die vor der Sitzungsvorbereitung für diesen Auftrag reserviert wurde.",
  "This component unit changed. Keep the recorded work and review the conflict.": "Diese Komponenteneinheit wurde geändert. Behalten Sie die erfasste Arbeit bei und prüfen Sie den Konflikt.",
  "This component revision changed. Keep the recorded work and review the conflict.": "Diese Komponentenrevision wurde geändert. Behalten Sie die erfasste Arbeit bei und prüfen Sie den Konflikt.",
  "This material lot changed. Keep the recorded work and review the stock conflict before submitting a correction.": "Diese Werkstoffcharge wurde geändert. Behalten Sie die erfasste Arbeit bei und prüfen Sie den Bestandskonflikt, bevor Sie eine Korrektur einreichen.",
  "This material revision changed. Keep the recorded work and review the conflict.": "Diese Werkstoffrevision wurde geändert. Behalten Sie die erfasste Arbeit bei und prüfen Sie den Konflikt.",
  "The command payload does not match its record type. Keep the original pending work for review.": "Die Aktionsdaten entsprechen nicht ihrem Datensatztyp. Behalten Sie die ursprüngliche ausstehende Arbeit zur Prüfung bei.",
  "Not started": "Nicht begonnen",
  "In progress": "In Bearbeitung",
  "Captured part revision was a draft.": "Die gesicherte Teilerevision war ein Entwurf.",
  "Captured configuration was a draft.": "Die gesicherte Konfiguration war ein Entwurf.",
  "A captured component revision was a draft.": "Eine gesicherte Komponentenrevision war ein Entwurf.",
  "Captured material revision was a draft.": "Die gesicherte Werkstoffrevision war ein Entwurf.",
  "Captured route revision was a draft.": "Die gesicherte Arbeitsplanrevision war ein Entwurf.",
  "A captured document revision was a draft.": "Eine gesicherte Dokumentrevision war ein Entwurf.",
  "No route was captured.": "Es wurde kein Arbeitsplan gesichert.",
  "An operation has no completed attempt.": "Für einen Arbeitsgang gibt es keinen abgeschlossenen Versuch.",
  "An expected inspection was not recorded.": "Eine vorgesehene Prüfung wurde nicht erfasst.",
  "The history includes failed operations.": "Der Verlauf enthält fehlgeschlagene Arbeitsgänge.",
  "The history includes skipped operations.": "Der Verlauf enthält übersprungene Arbeitsgänge.",
  "The history includes failed inspections.": "Der Verlauf enthält nicht bestandene Prüfungen.",
  "The history includes inconclusive inspections.": "Der Verlauf enthält nicht eindeutige Prüfungen.",
  "No inspection evidence was recorded.": "Es wurden keine Prüfnachweise erfasst.",
  "Planned components have no recorded actuals.": "Für geplante Komponenten wurden keine Istverbräuche erfasst.",
  "A planned component quantity differs from the recorded actuals.": "Eine geplante Komponentenmenge weicht von der erfassten Istmenge ab.",
  "Quality has not been declared.": "Der Qualitätsstatus wurde nicht erklärt.",
  "Production has not been declared.": "Der Produktionsstatus wurde nicht erklärt.",
  "Some actual components are recorded for the whole job, not an individual output.": "Einige tatsächliche Komponenten sind für den gesamten Auftrag statt für ein einzelnes Ergebnis erfasst.",
  "Some completed operations have no file evidence.": "Für einige abgeschlossene Arbeitsgänge fehlen Dateinachweise.",
  "An operation was recorded out of order.": "Ein Arbeitsgang wurde außerhalb der vorgesehenen Reihenfolge erfasst.",
  "The serial label is void.": "Die Serienkennzeichnung ist ungültig.",
  "Additional evidence warning recorded.": "Zusätzliche Nachweiswarnung erfasst.",
  "Document": "Dokument",
  "Applies to output": "Gilt für Ergebnis",
  "Earlier lot": "Frühere Charge",
  "From lot": "Aus Charge",
  "Captured component evidence": "Gesicherte Komponentennachweise",
  "Actual genealogy": "Tatsächliche Herkunft",
  "Related operation": "Zugehöriger Arbeitsgang",
  "Shared runs": "Gemeinsame Fertigungsläufe",
  "Add job to shared run": "Auftrag zum gemeinsamen Fertigungslauf hinzufügen",
  "Actual component type": "Typ der tatsächlichen Komponente",
  "CSV": "CSV",
  "An accepted recording command must confirm this evidence attachment.": "Eine angenommene Erfassungsaktion muss diese Nachweisanlage bestätigen.",
  "Choose a downloaded material lot or component serial.": "Wählen Sie eine heruntergeladene Werkstoffcharge oder serialisierte Komponente.",
  "Choose a supported evidence update.": "Wählen Sie eine unterstützte Nachweisaktualisierung.",
  "Choose a supported offline command and an object payload.": "Wählen Sie eine unterstützte Offline-Aktion mit Daten in Objektform.",
  "Choose the output receiving this component.": "Wählen Sie das Ergebnis, das diese Komponente aufnimmt.",
  "Evidence file references must be a list of server file IDs.": "Nachweisdateireferenzen müssen eine Liste von Serverdatei-IDs sein.",
  "Evidence upload failed.": "Nachweis-Upload fehlgeschlagen.",
  "Offline payloads must contain only JSON values.": "Offline-Aktionsdaten dürfen nur JSON-Werte enthalten.",
  "Online registry": "Online-Register",
  "Provide a corrected command payload object.": "Geben Sie die korrigierten Aktionsdaten als Objekt an.",
  "Provide the evidence upload error.": "Geben Sie den Nachweis-Uploadfehler an.",
  "Reconnect to verify recorder access before synchronizing.": "Verbinden Sie sich erneut, um vor der Synchronisierung den Zugriff der erfassenden Person zu prüfen.",
  "The offline bundle is missing selected material lots or component units.": "Im Offline-Paket fehlen ausgewählte Werkstoffchargen oder Komponenteneinheiten.",
  "The offline file SHA-256 does not match its manifest.": "Der SHA-256-Wert der Offline-Datei stimmt nicht mit ihrem Manifest überein.",
  "The offline file URL does not match its session.": "Die URL der Offline-Datei stimmt nicht mit ihrer Sitzung überein.",
  "The offline file length does not match its manifest.": "Die Größe der Offline-Datei stimmt nicht mit ihrem Manifest überein.",
  "The offline file manifest is invalid.": "Das Manifest der Offline-Datei ist ungültig.",
  "The offline manifest does not match the selected files.": "Das Offline-Manifest stimmt nicht mit den ausgewählten Dateien überein.",
  "The offline session does not belong to this recorder and job.": "Die Offline-Sitzung gehört nicht zu dieser erfassenden Person und diesem Auftrag.",
  "The prepared offline bundle does not match this recorder and job.": "Das vorbereitete Offline-Paket entspricht nicht dieser erfassenden Person und diesem Auftrag.",
  "The retained correction chain is incomplete.": "Die gespeicherte Korrekturkette ist unvollständig.",
  "The retained correction chain is invalid.": "Die gespeicherte Korrekturkette ist ungültig.",
  "The selected job changed. Open its download choices again.": "Der ausgewählte Auftrag wurde geändert. Öffnen Sie seine Download-Auswahl erneut.",
  "The selected offline file could not be downloaded.": "Die ausgewählte Offline-Datei konnte nicht heruntergeladen werden.",
  "The staged evidence failed SHA-256 verification.": "Der lokal vorgemerkte Nachweis hat die SHA-256-Prüfung nicht bestanden.",
  "The stored offline evidence failed SHA-256 verification.": "Der gespeicherte Offline-Nachweis hat die SHA-256-Prüfung nicht bestanden.",
  "The stored offline file failed SHA-256 verification.": "Die gespeicherte Offline-Datei hat die SHA-256-Prüfung nicht bestanden.",
  "This offline session is closed.": "Diese Offline-Sitzung ist geschlossen.",
  "This offline session is closed. Pending work is retained.": "Diese Offline-Sitzung ist geschlossen. Ausstehende Arbeit bleibt erhalten.",
  "Agent": "Agent",
  "Agents": "Agenten",
  "Member": "Mitglied",
  "Agent name": "Agentenname",
  "Agent reference": "Agentenreferenz",
  "Connected applications": "Verbundene Anwendungen",
  "Connection address": "Verbindungsadresse",
  "MCP endpoint": "MCP-Endpunkt",
  "New agent": "Neuer Agent",
  "Create agent": "Agent erstellen",
  "Manage": "Verwalten",
  "Review transfer": "Übertragung prüfen",
  "Management transfer awaiting your response": "Verwaltungsübertragung wartet auf Ihre Antwort",
  "Management transfer pending": "Verwaltungsübertragung ausstehend",
  "No connected applications.": "Keine verbundenen Anwendungen.",
  "No agents yet.": "Noch keine Agenten.",
  "Last used {date}": "Zuletzt verwendet: {date}",
  "Disconnect": "Trennen",
  "Disconnect {name}?": "{name} trennen?",
  "This application will lose access through this connection.": "Diese Anwendung verliert den Zugriff über diese Verbindung.",
  "Manage {name}?": "{name} verwalten?",
  "Accept management": "Verwaltung übernehmen",
  "Decline transfer": "Übertragung ablehnen",
  "Accepting management revokes the existing credentials. Create new credentials before running this agent again.": "Die Übernahme widerruft die bisherigen Zugangsdaten. Erstellen Sie vor dem nächsten Einsatz neue Zugangsdaten.",
  "Disabled": "Deaktiviert",
  "Enable agent": "Agent aktivieren",
  "Disable agent": "Agent deaktivieren",
  "Enable {name}?": "{name} aktivieren?",
  "Disable {name}?": "{name} deaktivieren?",
  "Rename": "Umbenennen",
  "Rename agent": "Agent umbenennen",
  "Transfer management": "Verwaltung übertragen",
  "Cancel transfer": "Übertragung abbrechen",
  "Request transfer": "Übertragung anfordern",
  "New manager’s Google account email": "Google-E-Mail-Adresse des neuen Verwalters",
  "Share agent reference": "Agentenreferenz teilen",
  "Company access": "Unternehmenszugriff",
  "No company access. A company owner can add this agent in Members.": "Kein Unternehmenszugriff. Ein Unternehmensinhaber kann den Agenten unter „Mitglieder“ hinzufügen.",
  "Credentials": "Zugangsdaten",
  "New credential": "Neue Zugangsdaten",
  "Create credential": "Zugangsdaten erstellen",
  "Credential name": "Name der Zugangsdaten",
  "No credentials yet.": "Noch keine Zugangsdaten.",
  "Rotate secret": "Geheimnis erneuern",
  "Rotate {name}?": "Geheimnis für {name} erneuern?",
  "Revoke {name}?": "{name} widerrufen?",
  "Create new credentials after enabling this agent.": "Erstellen Sie nach der Aktivierung neue Zugangsdaten.",
  "This revokes its credentials and stops access in every company.": "Dies widerruft die Zugangsdaten und beendet den Zugriff auf alle Unternehmen.",
  "Existing access tokens issued with this credential will stop working.": "Bisherige Zugriffstoken dieser Zugangsdaten werden ungültig.",
  "Connection credentials": "Verbindungszugangsdaten",
  "Client ID": "Client-ID",
  "Client secret": "Client-Geheimnis",
  "The secret is shown only once. Save it in your agent’s credential storage.": "Das Geheimnis wird nur einmal angezeigt. Speichern Sie es im Zugangsdaten-Speicher Ihres Agenten.",
  "The credential was created, but its secret cannot be shown again. Rotate the secret to replace it.": "Die Zugangsdaten wurden erstellt, das Geheimnis kann jedoch nicht erneut angezeigt werden. Erneuern Sie es.",
  "Copy {value}": "{value} kopieren",
  "Copy was unavailable. Select the value and copy it manually.": "Kopieren war nicht möglich. Markieren und kopieren Sie den Wert manuell.",
  "Add agent": "Agent hinzufügen",
  "Choose a valid agent reference.": "Geben Sie eine gültige Agentenreferenz an.",
  "Managed by {name}": "Verwaltet von {name}",
  "Connect application": "Anwendung verbinden",
  "Allow connection": "Verbindung erlauben",
  "Redirect address": "Weiterleitungsadresse",
  "This application can use your current company roles. Access follows changes to your memberships.": "Diese Anwendung kann Ihre aktuellen Unternehmensrollen nutzen. Der Zugriff folgt Änderungen Ihrer Mitgliedschaften.",
  "Agent created": "Agent erstellt",
  "Agent updated": "Agent aktualisiert",
  "Agent disabled": "Agent deaktiviert",
  "Credential created": "Zugangsdaten erstellt",
  "Credential rotated": "Zugangsdaten erneuert",
  "Credential revoked": "Zugangsdaten widerrufen",
  "Transfer requested": "Übertragung angefordert",
  "Transfer cancelled": "Übertragung abgebrochen",
  "Transfer accepted": "Übertragung angenommen",
  "Active agent not found.": "Aktiver Agent nicht gefunden.",
  "Agent not found.": "Agent nicht gefunden.",
  "Managed agent not found.": "Verwalteter Agent nicht gefunden.",
  "Credential not found.": "Zugangsdaten nicht gefunden.",
  "Connection not found.": "Verbindung nicht gefunden.",
  "Transfer not found.": "Übertragung nicht gefunden.",
  "This transfer has expired.": "Diese Übertragung ist abgelaufen.",
  "Choose another manager.": "Wählen Sie einen anderen Verwalter.",
  "The new manager must sign in to the registry first.": "Der neue Verwalter muss sich zuerst anmelden.",
  "A human account manages agent credentials.": "Agentenzugangsdaten werden von einem persönlichen Konto verwaltet.",
  "Enable the agent before creating credentials.": "Aktivieren Sie den Agenten, bevor Sie Zugangsdaten erstellen.",
  "Create a new credential after revocation.": "Erstellen Sie nach dem Widerruf neue Zugangsdaten.",
  "This agent is already a member.": "Dieser Agent ist bereits Mitglied.",
  "Another owner must accept membership before disabling the last owner.": "Ein weiterer Inhaber muss die Mitgliedschaft annehmen, bevor der letzte deaktiviert wird.",
  "Application not found.": "Anwendung nicht gefunden.",
  "Users": "Users",
  "Global directory": "Global directory",
  "Search people by name or email": "Search people by name or email",
  "Search users": "Search users",
  "All roles": "All roles",
  "All users": "All users",
  "Administrators": "Administrators",
  "Name / Email": "Name / Email",
  "Web-app role": "Web-app role",
  "Direct companies": "Direct companies",
  "Effective access": "Effective access",
  "Administrator": "Administrator",
  "User": "User",
  "No company access": "No company access",
  "{value0} companies": "{value0} companies",
  "{value0} of {value1} users": "{value0} of {value1} users",
  "No users match these filters.": "No users match these filters.",
  "Grant company access": "Grant company access",
  "No direct company access.": "No direct company access.",
  "Administrator · all companies": "Administrator · all companies",
  "Remove administrator": "Remove administrator",
  "Make administrator": "Make administrator",
  "Remove administrator?": "Remove administrator?",
  "Make administrator?": "Make administrator?",
  "This removes inherited access to every company. Direct memberships remain.": "This removes inherited access to every company. Direct memberships remain.",
  "This gives the user access to every company and the ability to manage users.": "This gives the user access to every company and the ability to manage users.",
  "Remove access?": "Remove access?",
  "Remove access to {value0}": "Remove access to {value0}",
  "Remove direct access to {value0}.": "Remove direct access to {value0}.",
  "Role for {value0}": "Role for {value0}",
  "Company role": "Company role",
  "Grant access": "Grant access",
  "Only web-app administrators can manage the user directory.": "Only web-app administrators can manage the user directory.",
  "Common parts": "Gemeinsame Teile",
  "Common": "Gemeinsam",
  "Add part to {value0}": "Teil zu {value0} hinzufügen",
  "Assembly actions": "Baugruppenaktionen",
  "Create symmetry": "Symmetrie erstellen",
  "Variant created.": "Variante erstellt.",
  "Symmetry family updated.": "Symmetriefamilie aktualisiert.",
  "Document categories": "Dokumentkategorien",
  "Document category": "Dokumentkategorie",
  "Add category": "Kategorie hinzufügen",
  "Edit category": "Kategorie bearbeiten",
  "Edit category {name}": "Kategorie {name} bearbeiten",
  "Category added.": "Kategorie hinzugefügt.",
  "Category saved.": "Kategorie gespeichert.",
  "Category name": "Kategoriename",
  "Category code": "Kategoriecode",
  "App default": "App-Standard",
  "Archived": "Archiviert",
  "Show archived categories": "Archivierte Kategorien anzeigen",
  "No categories available.": "Keine Kategorien verfügbar.",
  "Reload": "Neu laden",
  "Only company owners and editors can manage document categories.": "Nur Unternehmenseigentümer und Bearbeiter können Dokumentkategorien verwalten.",
  "Existing categories share these codes: {codes}. Their records remain separate.": "Bestehende Kategorien verwenden dieselben Codes: {codes}. Ihre Einträge bleiben getrennt.",
  "Upload document": "Dokument hochladen",
  "Apply to selected": "Auf Auswahl anwenden",
  "Back to files": "Zurück zu den Dateien",
  "Browser storage is unavailable. Keep this window open to retain your edits.": "Der Browserspeicher ist nicht verfügbar. Lassen Sie dieses Fenster geöffnet, um Ihre Änderungen zu behalten.",
  "Category for {name}": "Kategorie für {name}",
  "Check the saved upload change before continuing.": "Prüfen Sie die gespeicherte Upload-Änderung, bevor Sie fortfahren.",
  "Choose a matching document": "Passendes Dokument auswählen",
  "Choose which document should receive this revision.": "Wählen Sie das Dokument, dem diese Revision hinzugefügt werden soll.",
  "Create a separate document": "Separates Dokument erstellen",
  "Detected from": "Erkannt anhand von",
  "Drag and drop files here": "Dateien hierher ziehen",
  "Edit selected files": "Ausgewählte Dateien bearbeiten",
  "Edit {count} selected files": "{count} ausgewählte Dateien bearbeiten",
  "File details and applicability": "Dateidetails und Gültigkeit",
  "File preview": "Dateivorschau",
  "File size": "Dateigröße",
  "Filename": "Dateiname",
  "Keep current": "Aktuelle Werte behalten",
  "Matching document for {name}": "Passendes Dokument für {name}",
  "New document": "Neues Dokument",
  "New revision of {identifier}": "Neue Revision von {identifier}",
  "Next file": "Nächste Datei",
  "Not specified": "Nicht angegeben",
  "Preview unavailable for this file format.": "Für dieses Dateiformat ist keine Vorschau verfügbar.",
  "Preview {name}": "Vorschau von {name}",
  "Previous file": "Vorherige Datei",
  "Reading file details…": "Dateidetails werden gelesen…",
  "Recover saved upload": "Gespeicherten Upload wiederherstellen",
  "Select a file to preview.": "Wählen Sie eine Datei für die Vorschau.",
  "Select all files": "Alle Dateien auswählen",
  "Select files": "Dateien auswählen",
  "Select files to upload.": "Wählen Sie Dateien zum Hochladen.",
  "Select the original file to preview or resume.": "Wählen Sie die Originaldatei für die Vorschau oder zum Fortsetzen.",
  "Select the original file to resume.": "Wählen Sie die Originaldatei, um fortzufahren.",
  "Select {name}": "{name} auswählen",
  "Title for {name}": "Titel für {name}",
  "Title pattern": "Titelvorlage",
  "Uploading {name}": "{name} wird hochgeladen",
  "Use {name} for the current title and {n} for a sequence number.": "Verwenden Sie {name} für den aktuellen Titel und {n} für eine laufende Nummer.",
  "{count} files": "{count} Dateien",
  "{count} selected": "{count} ausgewählt",
  "{done} of {total} uploaded": "{done} von {total} hochgeladen",
  "Add files": "Dateien hinzufügen",
  "Retry unfinished uploads": "Unfertige Uploads erneut versuchen",
  "Drawing": "Zeichnung",
  "Assembly drawing": "Zusammenbauzeichnung",
  "Production drawing": "Fertigungszeichnung",
  "Bill of materials": "Stückliste",
  "Work instruction": "Arbeitsanweisung",
  "Schematic": "Schaltplan",
  "Wiring diagram": "Verdrahtungsplan",
  "Layout": "Anordnung",
  "3D model": "3D-Modell",
  "Test procedure": "Prüfverfahren",
  "Test report": "Prüfbericht",
  "Inspection plan": "Prüfplan",
  "Inspection report": "Inspektionsbericht",
  "Certificate": "Zertifikat",
  "Material datasheet": "Materialdatenblatt",
  "Calculation": "Berechnung",
  "Requirements": "Anforderungen",
  "Design report": "Konstruktionsbericht",
  "Assembly instruction": "Montageanleitung",
  "Manufacturing process": "Fertigungsprozess",
  "Quality plan": "Qualitätsplan",
  "Change notice": "Änderungsmitteilung",
  "Manual": "Handbuch",
  "Upload": "Hochladen",
  "Ready": "Bereit",
  "Needs attention": "Prüfung erforderlich",
  "Retained": "Aufbewahrt",
  "manual": "Manuell bearbeitet",
  "filename": "Dateiname",
  "embedded metadata": "Eingebettete Metadaten",
  "filename fallback": "Dateiname; allgemeine Kategorie",
  "Embedded metadata": "Eingebettete Metadaten",
  "Embedded title": "Eingebetteter Titel",
  "File selection key": "Dateiauswahlkennung",
  "Media type": "Medientyp",
  "Document category added": "Dokumentkategorie hinzugefügt",
  "Document category archived": "Dokumentkategorie archiviert",
  "Document category updated": "Dokumentkategorie aktualisiert",
  "Document upload batch created": "Dokument-Upload-Stapel erstellt",
  "Document draft retained": "Dokumententwurf aufbewahrt",
  "Document upload saved": "Hochgeladenes Dokument gespeichert",
  "Add a Company or Project category.": "Fügen Sie eine Unternehmens- oder Projektkategorie hinzu.",
  "Choose a category available in this document context.": "Wählen Sie eine in diesem Dokumentkontext verfügbare Kategorie.",
  "Choose a project only for a Project category.": "Wählen Sie ein Projekt nur für eine Projektkategorie.",
  "Choose the project that owns this document context.": "Wählen Sie das Projekt, zu dem dieser Dokumentkontext gehört.",
  "This category code already exists in this scope or an inherited scope. Choose another code.": "Dieser Kategoriecode existiert bereits in diesem oder einem übergeordneten Bereich. Wählen Sie einen anderen Code.",
  "This category is archived. Choose an available category.": "Diese Kategorie ist archiviert. Wählen Sie eine verfügbare Kategorie.",
  "This editable category was not found in this company.": "Diese bearbeitbare Kategorie wurde in diesem Unternehmen nicht gefunden.",
  "Use an uppercase alphanumeric category code starting with a letter.": "Verwenden Sie einen Kategoriecode aus Großbuchstaben und Ziffern, der mit einem Buchstaben beginnt.",
  "A saved document file cannot be removed from its upload batch.": "Eine gespeicherte Dokumentdatei kann nicht aus ihrem Upload-Stapel entfernt werden.",
  "A selected file key is already in this batch.": "Die Kennung einer ausgewählten Datei ist bereits in diesem Stapel enthalten.",
  "Choose a document category.": "Wählen Sie eine Dokumentkategorie.",
  "Choose a row in this upload batch.": "Wählen Sie eine Zeile in diesem Upload-Stapel.",
  "Choose an available document category.": "Wählen Sie eine verfügbare Dokumentkategorie.",
  "Choose between 1 and 1000 files.": "Wählen Sie zwischen 1 und 1000 Dateien.",
  "Choose distinct upload rows to edit.": "Wählen Sie unterschiedliche Upload-Zeilen zur Bearbeitung.",
  "Choose either an existing document or a new document.": "Wählen Sie entweder ein bestehendes oder ein neues Dokument.",
  "Resume this batch with the recorder who started it.": "Setzen Sie diesen Stapel mit dem Konto fort, das ihn gestartet hat.",
  "Several documents match this file. Choose the intended document or create a separate document.": "Mehrere Dokumente passen zu dieser Datei. Wählen Sie das gewünschte Dokument oder erstellen Sie ein separates.",
  "The selected document no longer matches this owner, category and title. Review the row again.": "Das gewählte Dokument passt nicht mehr zu diesem Eigentümer, dieser Kategorie und diesem Titel. Prüfen Sie die Zeile erneut.",
  "This document has an unfinished upload. Finish or cancel it before retrying this row.": "Dieses Dokument hat einen unvollständigen Upload. Beenden oder stornieren Sie ihn, bevor Sie diese Zeile erneut versuchen.",
  "This upload batch was cancelled.": "Dieser Upload-Stapel wurde abgebrochen.",
  "This upload row is already saved or cancelled.": "Diese Upload-Zeile wurde bereits gespeichert oder abgebrochen.",
  "Upload and verify this file before saving the document.": "Laden Sie diese Datei hoch und prüfen Sie sie, bevor Sie das Dokument speichern.",
  "Select the original file for this upload row.": "Wählen Sie die Originaldatei für diese Upload-Zeile.",
  "This row already has a different upload. Cancel that upload before replacing it.": "Diese Zeile hat bereits einen anderen Upload. Brechen Sie ihn ab, bevor Sie ihn ersetzen.",
  "Preview will be available after upload.": "Die Vorschau ist nach dem Hochladen verfügbar.",
  "existing document": "Vorhandenes Dokument",
  "file extension": "Dateierweiterung",
  "More": "Mehr",
  "Edit quantity for {value0}": "Menge für {value0} bearbeiten",
  "This structure cannot contain itself.": "Diese Struktur kann sich nicht selbst enthalten."
}
